import store from '../store/index.js';
import setState from '../lib/setState';
import constant from '../constants';
import { GpayGateway, ApplePayGateway } from '../index.js';
import { fieldsValidation } from './checkout';
import { importScript, chainLoader } from './scriptLoader';
import {
  FREE_PLAN,
  IOS_CHECKOUT_TEMPLATES,
  IOS_CHECKOUT_V2,
  IOS_CHECKOUT_V3,
  OS_ANDROID,
  OS_IOS,
  OS_MAC,
  OS_OTHER,
  OS_WINDOWS,
  PLG_CHECKOUT_TEMPLATES,
  SAME_RECURLY_STYLE_TEMPLATES,
  TEAMS,
  WINDOWS_IOS_CHECKOUT_TEMPLATES
} from '../constants/common.js';
import { ALREADY_AVAILED, ALREADY_SUBSCRIPTION, INSUFFICIENT_FUND } from '../constants/message.js';

let state = store.state.cartState ? store.state.cartState : {};

let scriptloaded = false;
window.addEventListener('scroll', loadAllScripts, { once: true });
window.addEventListener('keydown', loadAllScripts, { once: true });
window.addEventListener('mouseover', loadAllScripts, { once: true });
window.addEventListener('touchmove', loadAllScripts, { once: true });
window.addEventListener('touchstart', loadAllScripts, { once: true });

/* Recurly JS on load */
let recurlyExpiry = getTranslation('mm_yy');
let recurlyCardNumber = getTranslation('card_number');
let recurlyCvc = getTranslation('cvc_number');
let cardElement = {};

window.recurlyCardFields = {
  recurlyExpiry,
  recurlyCardNumber,
  recurlyCvc
};
window.recurlyElements = {};
window.onRecurlyCartJSLoad = onRecurlyCartJSLoad;

let recurlyConfig = Object.defineProperty({}, 'RECURLY_PUBLIC_KEY', {
  value: cartState.recurly_public_key || '',
  writable: false,
});

let colorValue = '#32325d';
let fontFamilyValue = 'avenir-roman, Helvetica, sans-serif';
let fontColorValue = '#545457';
let fontSizeValue = '14px';

if (SAME_RECURLY_STYLE_TEMPLATES.includes(state?.template_name)) {
  colorValue = '#d1d1d1';
  fontColorValue = '#d1d1d1';
  fontFamilyValue = "Inter, sans-serif";
} else if (state?.template_name === IOS_CHECKOUT_V2) {
  fontFamilyValue = "Inter, sans-serif";
  fontSizeValue = '12px';
} else if (state?.template_name === IOS_CHECKOUT_V3) {
  fontFamilyValue = "Inter, sans-serif";
  colorValue = '#00000099';
  fontColorValue = '#00000099';
}

function onRecurlyCartJSLoad() {
  recurly.configure({
    publicKey: recurlyConfig.RECURLY_PUBLIC_KEY,
    currency: cartState.currency_code,
  });

  recurlyElements = recurly.Elements();

  cardElement = recurlyElements.CardElement({
    style: {
      fontSize: fontSizeValue,
      color: colorValue,
      fontColor:  colorValue,
      fontFamily: fontColorValue,
      placeholder: {
        color: colorValue,
        content: {
          number: window.recurlyCardFields?.recurlyCardNumber || 'Card number',
          cvv: window.recurlyCardFields?.recurlyCvc || 'CVC',
          expiry: window.recurlyCardFields?.recurlyExpiry || 'MM / YY',
        },
      },
      invalid: {
        fontColor: '#fa755a',
      },
    },
  });

  let recurlyCardElement = document.querySelector('#card-element');

  if (recurlyCardElement) {
    cardElement.on('change', data => {
      const { number } = data;
      if (!number.empty) {
        removeCardLogo(recurlyCardElement);
      } else {
        addCardLogo(recurlyCardElement);
      }
      removeInputError(recurlyCardElement);
    });

    cardElement.on('blur', data => {
      const { state } = data;
      if (!state.number.empty) {
        fieldsValidation(recurlyCardElement);
      } else {
        removeInputError(recurlyCardElement);
      }
    });

    cardElement.attach('#card-element');
    renderComponents();
  }
}

function removeCardLogo(cardElement) {
  cardElement.classList.add('fade-out');
  setTimeout(() => {
    cardElement.classList.remove('card_logo');
    cardElement.classList.remove('fade-out');
  }, 500);
}

function addCardLogo(cardElement) {
  cardElement.classList.add('card_logo');
  setTimeout(() => {
    cardElement.classList.remove('fade-out');
  }, 100);
}

// for ga4 add_payment_info_event
window.isPaymentInfoEventSent = false;

/* Number format function */
export function getCurrencyFormat() {
  if (state.currency_code === 'EUR') {
    return {
      decimalPlaces: 2,
      decimalSeparator: ',',
      thousandSeparator: '.',
    };
  }

  return {
    decimalPlaces: 2,
    decimalSeparator: '.',
    thousandSeparator: ',',
  };
}

//get current price
export function getCurrentPrice(plan) {
  if (plan.discounted_amount) {
    return plan.discounted_amount + cartState.currencies_symbol[cartState.currency_code];
  }
  return plan.unit_amount + cartState.currencies_symbol[cartState.currency_code];
}

//get current price only
export function getCurrentPriceOnly(plan) {
  return plan.unit_amount + cartState.currencies_symbol[cartState.currency_code];
}

// currency selection dropdown
document.addEventListener('click', function (e) {
  let target = e.target;
  let dropdownListelement1 = target.closest('.currency-dropdown');
  removeClass('.currency-dropdown', 'cd-open');
  if (target.matches('.currency-selected, .currency-selected *')) {
    e.stopPropagation();
    dropdownListelement1.classList.add('cd-open');
  }
  /* country click listener*/
  if (target.matches('.cur-li, .cur-li *')) {
    e.stopPropagation();

    const currencyDropdownelement = document.querySelector('.currency-select-op');
    currencyDropdownelement.innerText = target.innerText;
    let selectedCurrency = target.innerText;

    currencySelected(selectedCurrency);
  }
});

// currency selection dropdown list generate - object list from database
populateCurrencyConverter();

/* Google renders either the old .gpay-card-info-container markup or a plain <button class="gpay-button"> */
export function clickGooglePayButton() {
  (document.querySelector('.gpay-card-info-container') || document.querySelector('#gpay-sec .gpay-button'))?.click();
}

export function loadAllScripts() {
  if (!scriptloaded) {
    scriptloaded = true;
    const loadscripts = [];
    if (state.captcha_enabled == '1') loadscripts.push('https://www.google.com/recaptcha/api.js?render=' + state.recaptcha_v3_site_key);

    importScript('https://js.recurly.com/v4/recurly.js')
      .then(() => {
        // load recurly elements
        onRecurlyCartJSLoad();
        chainLoader(loadscripts);
        // auto apply coupon from URL
        let urlParams = getParamFromURL();
        let coupon_code = urlParams.get('coupon');
        if (coupon_code) {
          applyCouponCode(coupon_code);
          document.querySelector('#desktop-coupon-box').style.display = 'none';
        }
        // Call the function to fetch and add JSON data to the window object
        fetchJsonAndAddToWindow("https://images.purevpn-tools.com/public-domain-list.json", "publicDomainList");
      })
      .catch(error => {
        console.error(error);
      });

    if (state?.device_fingerprint_enabled == '1' && state?.device_tracker_url) {
      importScript(state.device_tracker_url)
        .then(() => {
          window.IPQ = {
            Callback: function () {
              Startup.Pause();
              Startup.Init(); // Start the fraud tracker.

              Startup.AfterResult(function (result) {
                cartState.device_request_id = result?.request_id;
              });

              /*Startup.AfterFailure(function (reason) {
                console.log("device fingerprint failed reason-", reason)
              });*/
              Startup.Resume();
            }
          }
        })
    }
  }
}

// gpay method
export function getGpayOnGatewayChange(gatewayKey, GatewaysInstance) {
  let hide_btn = document.querySelector('#payment-button');
  let gpay_sec = document.querySelector('#gpay-sec');
  if (gatewayKey == 'gpay') {
    GpayGateway.loadGooglePayIfApplicable();
    gpay_sec.style.display = 'block';
    hide_btn.style.display = 'none';
    hide_btn.classList.remove('active');

    document.querySelector('.cart-cred').addEventListener('keypress', function (e) {
      // check if enter key is pressed
      if (e.keyCode == 13) {
        let isValid = fieldsValidation();
        if (isValid) {
          e.preventDefault();
          clickGooglePayButton();
        }
      }
    });
  } else {
    hide_btn.style.display = 'block';
    hide_btn.classList.add('active');
    if (gatewayKey != 'gpay') {
      gpay_sec.style.display = 'none';
    }
    if (gatewayKey == 'applepay') {
      ApplePayGateway.loadApplePayIfApplicable(GatewaysInstance);
    }
  }
}

// For bundle cart implmentation
export function getGatewayChange(gatewayKey, GatewaysInstance) {
  if (gatewayKey == 'gpay') {
    GpayGateway.loadGooglePayIfApplicable();
    document.querySelector('.cart-cred').addEventListener('keypress', function (e) {
      // check if enter key is pressed
      if (e.keyCode == 13) {
        let isValid = fieldsValidation();
        if (isValid) {
          e.preventDefault();
          clickGooglePayButton();
        }
      }
    });
  }
  else if (gatewayKey == 'applepay') {
    ApplePayGateway.loadApplePayIfApplicable(GatewaysInstance);
  }
}

export function numberFormat(number) {
  let priceFormat = getCurrencyFormat();
  var sign = number < 0 ? '-' : '';
  var i = String(parseInt((number = Math.abs(Number(number) || 0).toFixed(priceFormat.decimalPlaces))));
  var j = (j = i.length) > 3 ? j % 3 : 0;

  return (
    sign +
    (j ? i.substr(0, j) + priceFormat.thousandSeparator : '') +
    i.substr(j).replace(/(\decimalSeparator{3})(?=\decimalSeparator)/g, '$1' + priceFormat.thousandSeparator) +
    (priceFormat.decimalPlaces
      ? priceFormat.decimalSeparator +
      Math.abs(number - i)
        .toFixed(priceFormat.decimalPlaces)
        .slice(2)
      : '')
  );
}

export function getTranslation(translationKey) {
  let translation = state.trans[translationKey];
  return translation ? translation : translationKey;
}

export function isTeamPlan(plan) {
  return plan?.planGroup === TEAMS;
}

export function getAddonAmountAndQuantityForGA4(addonDetails, isTeamPlan = false) {
  const {PUREVPN_SEAT} = constant;
  const quantityKeys = isTeamPlan ? constant.quantityKeysByAddonForTeamPlan : constant.quantityKeysByAddon;
  const addon_quantity = Number(state[quantityKeys[addonDetails.code]]) || 1;
  let addon_amount = addonDetails.unit_amount;

  if (addonDetails.tiers?.length > 0) {
    let addon_tier = {};
    if (addonDetails.code === PUREVPN_SEAT) {
      addon_tier = addonDetails.tiers?.find(tier => addon_quantity <= tier.quantity);
      addon_amount = addon_tier?.unit_amount * addon_quantity;
    } else {
      addon_tier = addonDetails.tiers?.find(tier => tier.quantity === addon_quantity);
      addon_amount = addon_tier?.unit_amount;
    }
  } else {
    addon_amount = addon_amount * addon_quantity;
  }

  // round off to 2 decimal place
  addon_amount = Number(addon_amount.toFixed(2));

  return { addon_amount, addon_quantity };
}

export function GA4addPaymentInfoEvent() {

  let addonsList = state.selected_plan.addons;
  let order_value = state.selected_plan.adjustment ? state.selected_plan.discounted_amount : state.selected_plan.unit_amount;

  let items = [{
    discount: state.selected_plan.adjustment || 0,
    item_category: 'plan',
    item_id: state.selected_plan.code,
    item_name: state.selected_plan.name,
    price: state.selected_plan.unit_amount,
  }];

  if (state['selected_addons']) {
    state.selected_addons.forEach(function (element) {
      var selected_addon_detail = addonsList.find(function (el) {
        return el.code == element;
      });

      const { addon_amount, addon_quantity } = getAddonAmountAndQuantityForGA4(selected_addon_detail, isTeamPlan(state.selected_plan));

      order_value = order_value + addon_amount;

      items.push({
        discount: 0,
        item_category: 'addon',
        item_id: selected_addon_detail.code,
        item_name: selected_addon_detail.name,
        price: addon_amount/addon_quantity,
        quantity: addon_quantity,
      });
    });
  }
  let parameters = {
    parameters: {
      payment_type: state.selected_gateway_name,
      currency: state.currency_code,
      value: order_value,
      items: items,
    },
  };
  sendGa4CustomEvent('event_add_payment_info', parameters);
  window.isPaymentInfoEventSent = true;
}

export function sendGa4EcommerceEvent(event_name, items, value) {
  sendGa4CustomEvent('clear_ecommerce', { 'ecommerce': null })
  var data = {
    parameters: {
      'value': value,
      'currency': state.currency_code,
      'items': items
    }
  };
  sendGa4CustomEvent('event_' + event_name, data)
}

export function selectPlan(planIndex, extraState = null, data) {
  let newSelectedPlan = state.plans[planIndex];
  let oldSelectedPlan = state.selected_plan;

  sendGa4EventsOfSelectPlan(newSelectedPlan, oldSelectedPlan);

  let selectedAddons = cartState?.selected_addons || [];

  if (data) {
    selectedAddons = data?.selectedAddons || selectedAddons;
  }

  setState({
    selected_package_index: planIndex,
    selected_plan: newSelectedPlan,
    gateway_incentive_promo_code: '',
    selected_addons: selectedAddons,
    ...(extraState && extraState),
  });
}

export function populateCurrencyConverter() {
  // currency selection dropdown list generate - object list from database
  if (cartState.allow_currency_converter != 0) {
    let currLi = cartState.currencies;
    let listx = document.querySelector('.currency-option-card ul');
    if (listx) {
      for (let key in currLi) {
        let curLix = document.createElement('li');
        curLix.innerText = key;
        curLix.classList.add('cur-li', `${key.toLowerCase()}-icon`);
        listx.appendChild(curLix);
      }
    }
  }
}

export function currencySelected(selectedCurrency) {
  if (selectedCurrency) {
    cartState.currency_code = selectedCurrency;
    cartState.currency_symbol = cartState.currencies_symbol[selectedCurrency];

    for (let plan_currency in cartState.plans_currency) {
      //Plan Unit Amount Currency Update
      const currencyPlanData = cartState.plans_currency[plan_currency].currencies.filter(obj => obj.currency === selectedCurrency);
      cartState.plans[plan_currency].per_month = currencyPlanData[0].per_month;
      cartState.plans[plan_currency].unit_amount = currencyPlanData[0].unit_amount;

      // Plan Addon Currency update
      for (let addon_currency in cartState.plans_currency[plan_currency].addons) {
        const currencyAddonData = cartState.plans_currency[plan_currency].addons[addon_currency].currencies.filter(
          item => item.currency === selectedCurrency,
        );

        cartState.plans[plan_currency].addons[addon_currency].unit_amount = currencyAddonData[0].unit_amount;
      }

      // Displaying Billed Text
      cartState.plans[plan_currency].display_text = cartState.plans_currency[plan_currency].display_text[selectedCurrency];

      // pre applied addons - discounted amount and adjustment

      let appliedPromoCode = cartState.plans[plan_currency].pre_applied_promo_code;

      if (appliedPromoCode) {
        cartState.plans[plan_currency].discounted_amount = cartState.plans_currency[plan_currency].discounted_amount[selectedCurrency];
        cartState.plans[plan_currency].adjustment = cartState.plans_currency[plan_currency].adjustment_amount[selectedCurrency];
      } else {
        cartState.plans[plan_currency].discounted_amount = 0;
        cartState.plans[plan_currency].adjustment = 0;
      }
    }

    //hidden package setting pricing
    let incentivePlan = cartState.selected_plan;

    updateIncentivePlan(selectedCurrency, incentivePlan)

    setState();
  }
}

export function updateIncentivePlan(currency, incentivePlan) {
  incentivePlan = incentivePlan ?? getIncentivePlan();

  if (incentivePlan) {
    if (cartState.hidden_packages_currency && cartState.hidden_packages_currency[incentivePlan.code]) {

      const currencyIncentiveData = cartState.hidden_packages_currency[incentivePlan.code].currencies.filter(
        ob => ob.currency === currency
      );

      cartState.hidden_packages[incentivePlan.code].per_month = currencyIncentiveData[0].per_month;
      cartState.hidden_packages[incentivePlan.code].unit_amount = currencyIncentiveData[0].unit_amount;

      // check if fpdr coupon code available
      let couponIncentive = cartState.hidden_packages[incentivePlan.code].pre_applied_promo_code;

      if (couponIncentive) {
        cartState.hidden_packages[incentivePlan.code].discounted_amount =
          cartState.hidden_packages_currency[incentivePlan.code].discounted_amount[currency];

        if (cartState.hidden_packages_currency[incentivePlan.code].adjustment_amount) {
          cartState.hidden_packages[incentivePlan.code].adjustment = cartState.hidden_packages_currency[incentivePlan.code].adjustment_amount[currency];
        }
      }
    }
  }
}

export function updateIncentiveBox(incentivePlanDetails) {
  if (incentivePlanDetails) {
    let incentivePlan = getIncentivePlan();
    let incentivePlanCode = incentivePlan.code;

    document.querySelector('#incentive-box').innerHTML = document.querySelector('#incentive-box').innerHTML.replace(/\(month-cut-price\)/g, `${cartState.currencies_symbol[cartState.currency_code]}${cartState.old_prices[cartState.currency_code].purevpn}`);
    document.querySelector('#incentive-box').innerHTML = document.querySelector('#incentive-box').innerHTML.replace(/\(month-price\)/g, `${cartState.currencies_symbol[cartState.currency_code]}${cartState.hidden_packages[incentivePlanCode].per_month}`);
    document.querySelector('#incentive-box').innerHTML = document.querySelector('#incentive-box').innerHTML.replace(/\(price\)/g, `${getCurrentPrice(cartState.hidden_packages[incentivePlanCode])}`);
  }
}

export function updateGatewayIncentiveBox(gatewayIncentivePlanDetails, instance, gatewayIncentiveHtml) {
  if (gatewayIncentivePlanDetails) {
    if (gatewayIncentivePlanDetails.discounted_amount) {
      instance.element.innerHTML = gatewayIncentiveHtml;
      instance.element.innerHTML = gatewayIncentiveHtml.replace(/\(price\)/g, `${gatewayIncentivePlanDetails.billed_amount[cartState.currency_code]}${cartState.currencies_symbol[cartState.currency_code]}`);
    }
  }
}

export function selectGateway(gatewayKey, gatewayName) {
  if (gatewayKey !== state.selected_gateway) {
    /* Reseting incentive on gateway change */
    resetIncentiveOnGatewayChange(gatewayKey);

    setState({
      selected_gateway: gatewayKey,
      selected_gateway_name: gatewayName,
    });
  }
}

export function getSelectedGatewayOnLoad(gatewayIndex = 0, gatewayInfo = {}) {
  const selectedPlan = getSelectedPlan();
  let gateways = selectedPlan.gateways ?? selectedPlan.gateways;
  if (gateways && gateways[gatewayIndex]) {
    const selectedGateway = gateways[gatewayIndex];
    if (window.conditionalGateways && window.conditionalGateways[selectedGateway.logical_key] === false) {
      getSelectedGatewayOnLoad(gatewayIndex + 1, gatewayInfo);
    } else {
      gatewayInfo['gateway_key'] = selectedGateway.logical_key;
      gatewayInfo['gateway_name'] = selectedGateway.name;
    }
  }
  return gatewayInfo;
}

export function getSelectedPlan() {
  return state.selected_plan;
}

export function calculateDiscountedAmountAndPercentage(previousPrice, discountedPrice) {
  let discountAmount = 0;
  let discountPercentage = 0;

  if (previousPrice && discountedPrice) {
    let calculatedAmount = Number(previousPrice) - Number(discountedPrice);
    if (calculatedAmount) {
      discountAmount = calculatedAmount;

      let calculatedPercentage = ((Number(previousPrice) - Number(discountedPrice)) / Number(previousPrice)) * 100;

      if (calculatedPercentage) {
        discountPercentage = calculatedPercentage.toFixed();
      }
    }
  }

  return [discountPercentage, discountAmount];
}

export function calculateTotalOldPrice(planIntervalLength, oldPrice, currencyCode, selectedPlan) {
  const monthlyOldPrice = oldPrice[currencyCode] ? oldPrice[currencyCode] : {};
  let newOldPrice = window.OldPrice ? window.OldPrice : {};
  newOldPrice = newOldPrice[currencyCode] ? newOldPrice[currencyCode] : {};

  let oldPrices = {};
  for (let key in monthlyOldPrice) {
    oldPrices[key] = (newOldPrice[key]) ? Number(newOldPrice[key]) * Number(planIntervalLength) : Number(monthlyOldPrice[key]) * Number(planIntervalLength);
  }

  let { addons, description } = selectedPlan;
  let planType = isValidJSON(description) ? (JSON.parse(description).plan_type ?? null) : null; // vpn_max, vpn_plus
  let planGroup = isValidJSON(description) ? (JSON.parse(description).plan_group ?? null) : null; // family, duo
  let preSelectedAddon = state.pre_selected_addon.split(',');

  let sumRequiredAddonPrice = addons?.reduce((sum, addon) => {
    // for vpn cart
    return sum + (addon.optional == '0' && oldPrices[addon.code] ? oldPrices[addon.code] : 0);

  }, 0);

  // for family cart
  if (planGroup) {
    // exclude purepvn oldprice for teams dedicated ip plan
    if (planGroup == 'teams' && state.pre_selected_addon) {
      sumRequiredAddonPrice = sumRequiredAddonPrice - oldPrices['purevpn'] + oldPrices['teams'];
    }
    else {
      sumRequiredAddonPrice = oldPrices[planGroup] ? oldPrices[planGroup] : 0;
    }
  }
  // for bundle cart
  else if (planType) {
    sumRequiredAddonPrice = oldPrices[planType] ? oldPrices[planType] : 0;
  }
  // for special addons
  else if (!sumRequiredAddonPrice) {
    sumRequiredAddonPrice = oldPrices['purevpn'];
  }

  if (state.pre_selected_addon) {
    sumRequiredAddonPrice = Math.ceil(sumRequiredAddonPrice * 20) / 20; // round up to nearest 0.05
  }

  return sumRequiredAddonPrice;
}

export function calculateAddonOldPrice(oldPrices, selectedAddon, months, currencyCode) {
  let oldPrice = oldPrices[currencyCode];
  oldPrice = oldPrice[selectedAddon] || 0;
  oldPrice = Number(oldPrice) * Number(months);

  return oldPrice;
}

export function addCurrencySymbol(amount) {
  let currencySymbol = state.currency_symbol ? state.currency_symbol : '$';

  if (state.currency_code === 'EUR') {
    return (amount + '<span id="euro-right">' + currencySymbol + '</span>');
  }
  else {
    return ('<span id="euro-right">' + currencySymbol + '</span>' + amount);
  }
}

export function openAddonsCountryPopup(addonCode, cb = () => { }) {
  // Initialize values from cartState
  const { plans, selected_plan: selectedPlan, dedicatedIpsQuantity, teamQuantity, template_name: templateName, min_teams_quantity: minTeamQuantity, max_teams_quantity: maxTeamQuantity } = cartState;

  const hasTeamsPlan = plans.some(plan =>
    plan.planGroup?.toLowerCase() == "teams" &&
    (selectedPlan?.interval_length < 60 || templateName === "recurly-proplan-teams" || templateName === "recurly-proplan-teams-v4") // Will remove this when templates in which Teams Templates is in billing cycle will get removed.
  );
  const countryList = constant.addonsCountryList[addonCode];

  let ipCounterValue = Number(dedicatedIpsQuantity);
  let teamCounterValue = Number(teamQuantity);

  // Create dropdown options for country list
  const dropdownOptionsHtml = countryList
    .map(
      (country) => `
    <li class="ded-ip-dropdown-option" data-value="${country.code}">
      <i class="flag flag-${country.code.toLowerCase()}"></i> ${country.name}
      <span class="tick-mark">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 26 26" fill="none">
          <path d="M21.2829 6.38751L9.82454 17.8458L4.61621 12.6375" stroke="#119089" stroke-width="2.97396" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </li>`
    )
    .join("");

  // Render HTML for Teams Plan
  const renderTeamsPlanHtml = `
    <div class="teams-plan-header">
      ${getTranslation("dedicated_ip_popup_counter_hdg")}
      <p class="teams-plan-description">${getTranslation("dedicated_ip_popup_counter_para")}</p>
    </div>
    <div class="teams-plan-actions">
      <button class="counter-btn decrement" id="decrement-btn"><img src="https://images.purevpn-tools.com/wp-content/uploads/en/2024/12/Group-1321315072.png" loading="lazy"/></button>
      <div class="add-counter-combo">
        <button class="add-btn" id="add-btn">${getTranslation("dedicated_ip_popup_counter_cta")}</button>
        <div class="counter-display" id="counter-display">03</div>
      </div>
      <button class="counter-btn increment" id="increment-btn"><img src="https://images.purevpn-tools.com/wp-content/uploads/en/2024/12/Group-1321315071.png" loading="lazy"/></button>
    </div>`;

  // Render HTML for Explore Teams CTA
  const renderExploreTeamsHtml = `
    <div class="teams-plan-header">
      ${getTranslation("dedicated_ip_popup_explore_hdg")}
      <p class="teams-plan-description">${getTranslation("dedicated_ip_popup_explore_para")}</p>
    </div>
    <div class="teams-plan-actions">
      <a href="https://www.purevpn.com/business-vpn/vpn-for-teams" class="cta-explore-teams">
        <span class="teams-text">${getTranslation("dedicated_ip_popup_explore_cta")}</span>
        <span class="circle-arrow">
          <img decoding="async" loading="lazy" src="https://images.purevpn-tools.com/wp-content/uploads/en/2024/08/cta-arrow.webp" alt="arrow">
        </span>
      </a>
    </div>`;

  const teamsBoxHtml = hasTeamsPlan ? renderTeamsPlanHtml : renderExploreTeamsHtml;
  const excludedTemplates = ['recurly-proplan-teams-v14','recurly-proplan-teams-v8'];
  const shouldRenderTeamsCounter = !excludedTemplates.includes(templateName);

  // Popup HTML
  const popupHtml = `
    <div class="country-select-wrapper" style="display: block">
      <div class="ded-ip-dropdown-box">
        <span class="ded-ip-heading">${getTranslation("dedicated_ip_popup_heading")}</span>
        <div class="ded-ip-dropdown">
          <div class="ded-ip-dropdown-trigger">
            <span class="selected-country">${getTranslation("dedicated_ip_popup_select")}:</span>
            <i class="drop-arrow"></i>
          </div>
          <ul class="ded-ip-dropdown-options">${dropdownOptionsHtml}</ul>
        </div>
      </div>
      <div class="ded-ip-dropdown-btn">
        <button type="button" id="open-popup-confirm-btn" class="cta-dedicated disabled" disabled>
          ${getTranslation("dedicated_ip_popup_cta")}
        </button>
      </div>
    </div>

    ${shouldRenderTeamsCounter ? `
      <div class="or-breaker">${getTranslation("dedicated_ip_popup_text")}</div>
      <div class="teams-plan-container">${teamsBoxHtml}</div>` : ''}
  </div>`;

  openCustomModal(popupHtml, `customcartcountryPopup_${addonCode}`, "modalCountryClass", "625px");

  // If Teams Plan is available, enable counter logic
  if (hasTeamsPlan && shouldRenderTeamsCounter) {
    const counterDisplay = document.getElementById("counter-display");
    const incrementBtn = document.getElementById("increment-btn");
    const decrementBtn = document.getElementById("decrement-btn");
    const addBtn = document.getElementById("add-btn");

    // Function to update the counter display
    function updateCounterDisplay() {
      if (counterDisplay) {
        counterDisplay.textContent = String(ipCounterValue);
      }
      setState({
        dedicatedIpsQuantity: ipCounterValue,
        teamQuantity: teamCounterValue,
      });
      updateTeamsCounter();
      toggleIncrementButton();
    }

    // Function to update teams counters
    function updateTeamsCounter() {
      const teamsCounters = document.querySelectorAll(".team-input-number");
      teamsCounters?.forEach((teamInput) => {
        teamInput.value = String(teamCounterValue);
      });
    }

    // Function to toggle increment button based on value
    function toggleIncrementButton() {
      if (ipCounterValue >= maxTeamQuantity) {
        incrementBtn.classList.add("increment-btn-disabled");
        incrementBtn.disabled = true;
      } else {
        incrementBtn.classList.remove("increment-btn-disabled");
        incrementBtn.disabled = false;
      }
    }

    // Increment button functionality
    incrementBtn?.addEventListener("click", () => {
      if (ipCounterValue < maxTeamQuantity) {
        ipCounterValue++;
        if (ipCounterValue > teamCounterValue) {
          teamCounterValue = ipCounterValue;
        }
        updateCounterDisplay();
      }
    });

    // Decrement button functionality
    decrementBtn?.addEventListener("click", () => {
      if (ipCounterValue <= maxTeamQuantity && ipCounterValue > 0) {
        ipCounterValue--;
        if (ipCounterValue < minTeamQuantity) {
          teamCounterValue = minTeamQuantity;
        } else if (teamCounterValue > ipCounterValue) {
          teamCounterValue = ipCounterValue;
        }
        updateCounterDisplay();
      }
    });

    updateCounterDisplay();

    // Add button click event
    addBtn?.addEventListener("click", () => {
      const teamsBox = document.querySelector( // Will remove this when templates in which Teams Templates is in billing cycle will get removed.
        `[data-billing-cycle="${selectedPlan?.billing_cycle}"] .cart-box.teams-box`
      ) || document.querySelector(".teams-plan-box-wrapper .cart-box.teams-box") || document.querySelector(
        `[data-billing-cycle="${selectedPlan?.billing_cycle}"] .cart-box.type-teams`);
      if (teamsBox) {
        if (ipCounterValue == 0) {
          setState({
            dedicatedIpsQuantity: 1,
          });
        }
        teamsBox.click();
        addAddon(constant?.DEDICATED_IP, null, false, null, TEAMS);

        const gatewaySection = document.getElementById("gateway-for-scroll");
        if (gatewaySection) {
          gatewaySection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          closeCustomPopup();
        }
      }
    });
  }

  // Handle dropdown interactions
  const dedIpDropdown = document.querySelector(".ded-ip-dropdown");
  const dedIpTrigger = dedIpDropdown?.querySelector(".ded-ip-dropdown-trigger");
  const dedIpOptions = dedIpDropdown?.querySelectorAll(".ded-ip-dropdown-option");
  const selectedCountry = dedIpDropdown?.querySelector(".selected-country");
  const confirmButton = document.querySelector("#open-popup-confirm-btn");
  let selectedValue = null;

  // Open dropdown on click
  dedIpTrigger?.addEventListener("click", (e) => {
    if (!e.target.closest(".ded-ip-dropdown-option")) {
      dedIpDropdown.classList.toggle("open");
    }
  });

  // Handle country selection in dropdown
  dedIpOptions?.forEach((option) => {
    option.addEventListener("click", (e) => {
      e.stopPropagation();
      selectedValue = option.getAttribute("data-value");
      const flagClass = option.querySelector("i")?.className;
      const selectedName = option.childNodes[2]?.textContent.trim();

      // Update selected country
      dedIpOptions.forEach((opt) => opt.classList.remove("selected"));
      option.classList.add("selected");

      if (selectedCountry) {
        selectedCountry.innerHTML = `<i class="${flagClass}"></i> ${selectedName}`;
      }

      dedIpDropdown.classList.remove("open");

      if (confirmButton) {
        confirmButton.disabled = false;
        confirmButton.classList.remove("disabled");
      }
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener("click", (e) => {
    if (!dedIpDropdown.contains(e.target) && !dedIpTrigger.contains(e.target)) {
      dedIpDropdown.classList.remove("open");
    }
  });

  // Confirm country selection
  confirmButton?.addEventListener("click", () => {
    if (selectedValue) {
      cb();
      addAddon(addonCode, selectedValue);
      closeCustomPopup();
    }
  });
}

export function openAddonsCountryCitiesPopup(addonCode) {
  let popupHtml = `<div class="city-select-wrapper">
                      <div class="select-option-card">
                        <span class="heading"> Select City </span>
                        <ul>`;

  popupHtml += cartState.dedicated_server_locations.reduce((previousValue, currentValue) => {
    const cities = currentValue?.cities?.reduce(
      (cityAcc, city) => cityAcc + `<li class="city inner_list" data-city="${city.city_code3}">
      <label class="radio"><input type="radio" name="${addonCode}" value="${city.city_code3
        }">
      <span>${city.city_name}</span></label></li>`,
      '',
    );

    return (
      previousValue +
      `<li class="country-list" data-country="${currentValue?.country_code3}">` +
      `<span><i class="flag flag-${currentValue.country_code2.toLowerCase()}"></i> <i>${currentValue.country_name}</i></span>` +
      (cities ? `<ul class="city-list">${cities}</ul>` : '') +
      `</li>`

    );
  }, '');
  popupHtml += `          </ul>
  <div class="modal-divider"></div>
                       </div>
                  </div>
                  <button type="button" id="open-popup-confirm-btn" class="openPopupConfirmBtn" style="display: inline-block; border-left-color: rgb(40, 198, 117); border-right-color: rgb(40, 198, 117);">${getTranslation('get') + ' ' + getTranslation(addonCode)}</button>

                  `;


  let modalCountryCities = `customcartcountrycitiesPopup_${addonCode}`;

  openCustomModal(popupHtml, modalCountryCities, 'modalCityClass', '250px');

  let confirmAddonBtnn = document.querySelector('.openPopupConfirmBtn');

  if (confirmAddonBtnn) {
    confirmAddonBtnn.addEventListener('click', () => {
      const addonCityElement = document.querySelector(`input[name="${addonCode}"]:checked`);
      if (addonCityElement) {
        let addonCity = addonCityElement.value;
        if (addonCity !== '') {
          const addonCity = addonCityElement.value;
          const addonCountryElement = addonCityElement.closest('.country-list');
          const addonCountry = addonCountryElement?.getAttribute('data-country');
          addAddon(addonCode, addonCountry, false, addonCity);
          closeCustomPopup();
        }
      }
      else {
        closeCustomPopup();
      }
    });
  }
}

export function openAddonsMultiLoginPopup(addonCode) {
  const multiLogin = cartState.selected_plan.addons.find(item => item.code === addonCode);
  let unitAmount = multiLogin?.unit_amount ? Number(multiLogin.unit_amount) / Number(cartState.selected_plan.interval_length) : 0;
  let templateName = cartState.template_name;
  const excludedTemplates = ['recurly-proplan-teams-v14','recurly-proplan-teams-v8'];

  let popupHtml = `<div class="multilogin-select-wrapper">
                      <div class="select-option-card text-left">
                        <h4 class="heading mb-2">${getTranslation('multi_login_tier_popup_heading')}</h4>
                        <span class="sub_heading">${getTranslation('multi_login_tier_popup_text')}</span>
                        <ul class="mt-4">`;

  popupHtml += multiLogin.tiers.reduce(function (previousValue, currentValue) {
    let addonPrice = currentValue?.unit_amount ? Number(currentValue.unit_amount) / Number(cartState.selected_plan.interval_length) : 0;
    return (
      previousValue +
      `<li>
        <label class="radio">
            <div class="login_count">
              <h4>${currentValue.quantity}</h4>
              <span>${getTranslation('multi_login_tier_popup_total_login')}</span>
              <span class="mt-3"><b>${addCurrencySymbol(numberFormat(addonPrice))}</b>${getTranslation('multi_login_tier_popup_per_month')}</span>
            </div>
            <input type="radio" name="${addonCode}" value="${currentValue.quantity}">
        </label>
      </li>`
    );
  }, '');

  popupHtml += `          </ul>
                       </div>
                  </div>
                  <div class="d-flex py-4 align-items-center privacy-policy">
                    <span class="flex-fill text-left">${getTranslation('multi_login_tier_popup_terms_service')}</span>
                    <button type="button" id="open-popup-confirm-btn" class="openPopupConfirmBtn purple">${getTranslation('multi_login_tier_popup_cta')}</button>
                  </div>
                  ${
                    !excludedTemplates.includes(templateName) ? `
                    <div class="modal-footer">
                    <div class="container p-4">
                      <div class="row">
                        <div class="col-7 text-left">
                          <h5 class="mb-3">${getTranslation('multi_login_tier_popup_btm_heading')}</h5>
                          <span>${getTranslation('multi_login_tier_popup_btm_text')}</span>
                        </div>
                        <div class="col-5">
                          <div class="d-flex justify-content-end text-left">
                            <div>
                              <p>Starting from</p>
                              <p class="text-yellow">${getTranslation('multi_login_tier_popup_btm_price')}</p>
                            </div>
                            <div><a href="${getTranslation('multi_login_tier_popup_btm_link')}" target="_blank"><img src="https://images.purevpn-tools.com/wp-content/uploads/en/2024/08/Group-1321314644.webp" /></a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  ` : ''}`;


  const modalMultiLogin = `customcartPopup_${addonCode}`;

  openCustomModal(popupHtml, modalMultiLogin, 'modalMultiLoginClass');

  const confirmAddonBtnn = document.querySelector('.openPopupConfirmBtn');

  if (confirmAddonBtnn) {
    confirmAddonBtnn.addEventListener('click', () => {
      const addonLoginElement = document.querySelector(`input[name="${addonCode}"]:checked`);
      if (addonLoginElement) {
        let quantity = addonLoginElement.value;

        // First update the state with the selected quantity
        setState({
          multiLoginQuantity: quantity
        });

        addAddon(addonCode, null, false, null, '', quantity);
        closeCustomPopup();
      }
      else {
        closeCustomPopup();
      }
    });
  }

  const multiLoginUl = document.querySelector('.multilogin-select-wrapper ul');
  if (multiLoginUl) {
    multiLoginUl.addEventListener('click', function (e) {
      const clickedLi = e.target.closest('li');
      if (!clickedLi) return;

      const activeLi = multiLoginUl.querySelector('.active');
      if (activeLi !== clickedLi) {
        if (activeLi) activeLi.classList.remove('active');
        clickedLi.classList.add('active');
      }
    });
  }

}

export function openAddonsResidentNetworkPopup(addonCode) {
  const residential_network_bandwidth = cartState.selected_plan.addons.find(item => item.code === addonCode);

  let selectedAmount = 0;
  let selectedQuantity = null;

  let popupHtml = `<div class="resident-network-select-wrapper">
                      <div class="select-option-card text-left">
                        <h4 class="resendial-popup-heading heading">${getTranslation('residential_network_pop_up_heading')}</h4>
                        <ul class="mt-4">`;

  popupHtml += residential_network_bandwidth.tiers.reduce(function (previousValue, currentValue) {
    const numberOfMonths = cartState.selected_plan?.months || cartState.selected_plan?.interval_length;
    const addonPrice = currentValue?.unit_amount ? Number(currentValue.unit_amount) / Number(numberOfMonths) : 0;
    return (
      previousValue +
      `<li>
        <label class="radio">
            <div class="login_count">
              <h4>${currentValue.quantity}</h4>
              <span>${getTranslation('GB')}</span>
              <span class="mt-3"><b>${addCurrencySymbol(numberFormat(addonPrice))}</b>${getTranslation('multi_login_tier_popup_per_month')}</span>
            </div>
            <input type="radio" name="${addonCode}" value="${currentValue.quantity}" data-amount="${currentValue.unit_amount}">
        </label>
      </li>`
    );
  }, '');

  popupHtml += `          </ul>
                       </div>
                  </div>

                  <div class="rn-popup-border"></div>

                  <div class="rn-popup-fold">
                    <div class="rn-popup-fold-media">
                      <img src="https://images.purevpn-tools.com/wp-content/uploads/en/2026/09/rn-popup-fold.webp" alt="IP Per Tab For Chrome" loading="lazy">
                    </div>
                    <div class="rn-popup-fold-content-box">
                      <div class="rn-popup-fold-content">
                        <h4>${getTranslation('residential_network_ip_per_tab_heading')}</h4>
                        <p>${getTranslation('residential_network_ip_per_tab_para')}</p>
                      </div>
                      <div class="rn-popup-fold-badge">${getTranslation('residential_network_ip_per_tab_included')}</div>
                    </div>
                  </div>

                  <div class="total-amount-rn d-flex justify-content-between">
                    <div><h3>Total Amount</h3></div>
                    <div><h5 id="total-amount">$0</h5></div>
                  </div>
                  <div class="resident-network-popup-btn">
                    <button type="button" id="open-popup-confirm-btn" class="openPopupConfirmBtn purple">${getTranslation('multi_login_tier_popup_cta')}</button>
                  </div>
                  `;

  const modalMultiLogin = `customcartPopup_${addonCode}`;
  openCustomModal(popupHtml, modalMultiLogin, 'modalMultiLoginClass modalResidentNetwork', '624px');

  // Add event listener to update total amount when radio button is selected
  const multiLoginUl = document.querySelector('.resident-network-select-wrapper ul');
  if (multiLoginUl) {
    multiLoginUl.addEventListener('click', function(e) {
      const clickedLi = e.target.closest('li');
      if (!clickedLi) return;

      const activeLi = multiLoginUl.querySelector('.active');
      const confirmBtn = document.querySelector('.resident-network-popup-btn .openPopupConfirmBtn');
      const selectedRadio = clickedLi.querySelector('input[type="radio"]');
      const totalAmountElement = document.getElementById('total-amount');

      if (activeLi !== clickedLi) {
        if (activeLi) activeLi.classList.remove('active');
        clickedLi.classList.add('active');

        // Update total amount and store selected quantity
        if (selectedRadio && totalAmountElement) {
          selectedAmount = Number(selectedRadio.getAttribute('data-amount'));
          selectedQuantity = selectedRadio.value;
          totalAmountElement.innerHTML = `${addCurrencySymbol(numberFormat(selectedAmount))}`;
        }

        // Update button style when radio is selected
        if (confirmBtn) {
          confirmBtn.setAttribute('style', 'background-color: #550CCB !important; color: #FFFFFF !important');
        }
      }
    });
  }

  // Add confirm button click handler
  const confirmBtn = document.querySelector('.resident-network-popup-btn .openPopupConfirmBtn');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', () => {
      if (selectedQuantity) {
        // First update the state with the selected quantity
        setState({
          residentialNetworknBandwidthQuantity: selectedQuantity
        });

        // Then add the addon with the selected quantity
        addAddon(addonCode, null, false, null, '', '', selectedQuantity);
        closeCustomPopup();
      }
    });
  }
}

export function addAddon(addonKey, addonCountry = null, hideCountry = false, addonCity = null, planGroup = '', multiLogin = '', resendentialNetworkBandwidth = '') {
  const addonWithCountries = constant.addonWithCountries;
  const addonWithCities = constant.addonWithCities;
  const addonKeys = Array.isArray(addonKey) ? addonKey : [addonKey];

  let addonState = {};
  addonState['selected_addons'] = state.selected_addons ? state.selected_addons : [];

  for (let key of addonKeys) {
    if (!addonState['selected_addons'].includes(key)) {
      if (planGroup !== TEAMS) {
        if (addonWithCountries.includes(key) && hideCountry === false && !addonCountry) {
          console.error(`Country is required for ${key}`);
          return;
        }
        if (addonWithCities.includes(key) && !addonCity) {
          console.error(`City is required for ${key}`);
          return;
        }
      }

      const addonsTobeDisabled = constant.addonsToBeDisabled[key] ? constant.addonsToBeDisabled[key] : [];

      if (addonsTobeDisabled.length) {
        let disabledAddons = addonsTobeDisabled;
        if (state.disable_addons) {
          disabledAddons = [...state.disable_addons, ...disabledAddons]
          disabledAddons = [... new Set(disabledAddons)] //remove duplicates
        }
        addonState['disable_addons'] = disabledAddons;
      }

      addonState['selected_addons'] = [...addonState['selected_addons'], key];
      if (addonCountry) {
        const addonCountryKey = 'addon_country' + (addonCountry?.length === 3 ? '3' : '');
        addonState[addonCountryKey] = addonCountry;
      }
      if (addonCity) addonState['addon_city'] = addonCity;
      if (multiLogin) addonState['multiLoginQuantity'] = multiLogin;

      if (resendentialNetworkBandwidth) addonState['residentialNetworknBandwidthQuantity'] = resendentialNetworkBandwidth;

      /* add_to_cart event ga4 */
      const selected_addon_detail = state.selected_plan.addons.find(el => el.code === key);
      if (selected_addon_detail) {
        const { addon_amount, addon_quantity } = getAddonAmountAndQuantityForGA4(selected_addon_detail, isTeamPlan(state.selected_plan));

        const items = [
          {
            'discount': 0,
            'item_category': 'addon',
            'item_id': selected_addon_detail.code,
            'item_name': selected_addon_detail.name,
            'price': addon_amount/addon_quantity,
            'quantity': addon_quantity,
          }
        ];
        sendGa4EcommerceEvent('add_to_cart', items, addon_amount);
      }
      sendGaCustomEvent('Order Cart', 'Add On Select', key, '1');
    }
  }

  if (addonState['selected_addons'].length) setState(addonState);
}

export function removeAddon(addonKey) {
  const addonKeys = Array.isArray(addonKey) ? addonKey : [addonKey];
  let selectedAddons = state.selected_addons ? state.selected_addons : [];
  let disabledAddons = state.disable_addons ? state.disable_addons : [];
  disabledAddons = [... new Set(disabledAddons)] //remove duplicates

  let addonState = {};
  addonState['selected_addons'] = state.selected_addons ? state.selected_addons : [];

  for (let key of addonKeys) {
    if (!selectedAddons.includes(key)) {
      console.error(`No addon found with the name ${key} while removing`);
      return;
    }

    const addonsTobeDisabled = constant.addonsToBeDisabled[key] ? constant.addonsToBeDisabled[key] : [];

    if (addonsTobeDisabled.length) {
      let newDisabledAddons = [...disabledAddons];
      for (let addon of addonsTobeDisabled) {
        var index = newDisabledAddons.indexOf(addon);
        if (index !== -1) {
          newDisabledAddons.splice(index, 1);
        }
      }

      addonState['disable_addons'] = newDisabledAddons;

      // Reevaluate disabled addons based on the remaining addons
      const remainingAddons = selectedAddons.filter(addon => addon !== key);
      for (const remainingAddon of remainingAddons) {
        const remainingAddonsToBeDisabled = constant.addonsToBeDisabled[remainingAddon];
        if (remainingAddonsToBeDisabled) {
          addonState['disable_addons'].push(...remainingAddonsToBeDisabled);
        }
      }
    }

    addonState['selected_addons'] = addonState['selected_addons'].filter(addon => addon !== key);

    const isCountryAddonselected = addonState['selected_addons'].some(val => val in constant.addonsCountryList);
    if (!isCountryAddonselected) {
      addonState['addon_country'] = '';
    }

    const isCityAddonselected = addonState['selected_addons'].includes(constant.DEDICATED_SERVER);
    if (!isCityAddonselected) {
      addonState['addon_country3'] = '';
      addonState['addon_city'] = '';
    }

    const isMultiLoginAddonselected = addonState['selected_addons'].includes(constant.MULTI_LOGIN);
    if (!isMultiLoginAddonselected) {
      addonState['multiLoginQuantity'] = '';
    }

    const isResidentialNetworkBandwidthAddonselected = addonState['selected_addons'].includes(constant.RESIDENTIAL_NETWORK_BANDWIDTH);
    if (!isResidentialNetworkBandwidthAddonselected) {
      addonState['residentialNetworknBandwidthQuantity'] = '';
    }

    /* remove_from_cart event ga4 */
    const removed_addon_detail = state.selected_plan.addons.find(el => el.code === key);
    if (removed_addon_detail) {
      const { addon_amount, addon_quantity } = getAddonAmountAndQuantityForGA4(removed_addon_detail, isTeamPlan(state.selected_plan));

      const items = [
        {
          'discount': 0,
          'item_category': 'addon',
          'item_id': removed_addon_detail.code,
          'item_name': removed_addon_detail.name,
          'price': addon_amount/addon_quantity,
          'quantity': addon_quantity,
        }
      ];
      sendGa4EcommerceEvent('remove_from_cart', items, addon_amount);
    }
  }

  setState(addonState);
}


export function applyCouponCode(coupon_code, hide = false, global = false) {
  setState({ coupon_code, coupon_hide: hide, coupon_special: global });
}

export function removeCouponCode() {
  // if special or url coupon applied then don't remove
  let urlParams = getParamFromURL();
  let coupon_code = urlParams.get('coupon');
  if (coupon_code === state.coupon_code || state.coupon_special) {
    document.querySelector('#desktop-coupon-box').style.display = 'none';
    return;
  }

  const couponMessageElement = document.querySelector('.payment-coupon-box-message');
  const couponInput = document.querySelector('#coupon-input');
  const couponSubmitButton = document.querySelector('#coupon-submit');
  const couponRemoveButton = document.querySelector('.payment-coupon-cancel');

  document.querySelector('.coupon-box-input').classList.remove('red');
  if (couponMessageElement) {
    couponMessageElement.innerHTML = ``;
    couponMessageElement.classList.remove('active');
  }

  couponInput.classList.remove('disabled');
  couponInput.value = '';
  couponSubmitButton.classList.remove('disabled');
  couponRemoveButton.classList.remove('show');
  if (state.coupon_code) setState({ coupon_code: '' });
}

export function showCouponResponcse(success) {
  // if special or url coupon applied then don't remove
  let urlParams = getParamFromURL();
  let coupon_code = urlParams.get('coupon');
  if (coupon_code === state.coupon_code || state.coupon_special) {
    document.querySelector('#desktop-coupon-box').style.display = 'none';
    return;
  }

  const couponMessageElement = document.querySelector('.payment-coupon-box-message');
  const couponInput = document.querySelector('#coupon-input');
  const couponSubmitButton = document.querySelector('#coupon-submit');
  const couponRemoveButton = document.querySelector('.payment-coupon-cancel');

  if (success) {
    document.querySelector('.coupon-box-input').classList.remove('red');
    if (couponMessageElement) {
      couponMessageElement.innerHTML = `<p class='green'>${cartParams.trans.discount_applied}</p>`;
      couponMessageElement.classList.add('active');
    }

    couponInput.classList.add('disabled');
    couponSubmitButton.classList.add('disabled');
    couponRemoveButton.classList.add('show');
    return;
  }

  document.querySelector('.coupon-box-input').classList.add('red');
  if (couponMessageElement) {
    couponMessageElement.innerHTML = `<p class='red'>${cartParams.trans.invalid_coupon}</p>`;
    couponMessageElement.classList.add('active');
  }

  couponInput.classList.remove('disabled');
  couponSubmitButton.classList.remove('disabled');
  couponRemoveButton.classList.remove('show');
  if (state.coupon_code) setState({ coupon_code: '' });
}

export function showTweetResponse(success, tweetBoxMessage, tweet_pll = '') {

  if (success) {
    document.querySelector('#coupon-toggle').style.display = 'none'; //hide frontend coupon toggle
    document.querySelector('.coupon-box-input').classList.remove('active'); //hide frontend coupon box
    applyCouponCode('pure100', true); //if true then hide coupon in frontend
    return;
  }

  tweetBoxMessage.innerHTML = `<p style='color:#f45f5f'>${tweet_pll}</p>`;

  if (state.coupon_code) setState({ coupon_code: '' });
}

export function isTrialPlan(planObject = null) {
  if (!planObject) planObject = state.selected_plan;
  return planObject.trial_length == '0' ? false : true;
}

export function isFpdrPlan(planObject = null) {
  if (!planObject) planObject = state.selected_plan;
  return planObject.pre_applied_promo_code ? true : false;
}

export function isProPlan(planObject = null) {
  if (!planObject) planObject = state.selected_plan;
  try {
    let planDescription = JSON.parse(planObject.description);
    return planDescription.is_proplan == true ? true : false;
  } catch (err) { }

  return false;
}

export function isAddonCart(planObject = null) {
  if (!planObject) planObject = state.selected_plan;

  return (state.pre_selected_addon && planObject.setup_fee === 0 && planObject.unit_amount === 0) ? true : false;
}

export function getIncentivePlanDetails(planObject = null, gateway = null) {
  if (!planObject) planObject = state.selected_plan;

  let incentivePlans = state.hidden_products_association;
  incentivePlans = incentivePlans && incentivePlans[planObject.code] ? incentivePlans[planObject.code] : {};

  let incentivePlanDetailsObject = incentivePlans[gateway ? gateway : state.selected_gateway];

  return incentivePlanDetailsObject ? incentivePlanDetailsObject : false;
}

export function getIncentivePlan(planCode = null) {
  let selectedPlan = state.selected_plan;
  let incentivePlanDetails = getIncentivePlanDetails();

  if (!planCode)
    planCode = incentivePlanDetails.sku;

  let hiddenPlans = state.hidden_packages ? state.hidden_packages : {};

  /* Adding incentive promo code in plan details and adding parent plan's gateways in incentive plan object*/
  if (hiddenPlans[planCode]) {
    // For bundle cart implmentation
    if (state.proplan_packages !== null) {
      if (state.proplan_packages?.[planCode]) {
        let cartElement = document.querySelector(`.plan-box-wrapper .cart-box[data-plan-code="${planCode}"]`);
        let tabElement = cartElement.getAttribute('data-tab-code');
        removeClass('.plan-tabs-wrap ul li', 'active');
        removeClass('.plan-box-wrapper', 'active');
        addClass(`.plan-tabs-wrap ul [data-tabs="${tabElement}"]`, 'active');
        addClass(`.plan-box-wrapper.${tabElement}`, 'active');
        cartElement.click();
        return;
      }
      else {
        removeClass('.plan-tabs-wrap ul li', 'active');
        hiddenPlans[planCode]['is_incentive_plan'] = true;
        hiddenPlans[planCode]['incentive_promo_code'] = incentivePlanDetails.promo_code;
        hiddenPlans[planCode]['gateways'] = selectedPlan.gateways;
      }
    }
    else {
      hiddenPlans[planCode]['is_incentive_plan'] = true;
      hiddenPlans[planCode]['incentive_promo_code'] = incentivePlanDetails.promo_code;
      hiddenPlans[planCode]['gateways'] = selectedPlan.gateways;
    }
  }

  return hiddenPlans[planCode] ? hiddenPlans[planCode] : false;
}

export function selectIncentive() {
  let incentivePlan = getIncentivePlan();
  let selectedCurrency = cartState.currency_code;

  updateIncentivePlan(selectedCurrency, incentivePlan)
  setState({ selected_package_index: null, selected_plan: incentivePlan, incentive_host_plan_index: state.selected_package_index, coupon_code: '' });
}

export function resetIncentive() {
  selectPlan(state.incentive_host_plan_index, { incentive_host_plan_index: null });
}

export function resetIncentiveOnGatewayChange(gatewayKey) {
  const selectedPlan = getSelectedPlan();

  if (selectedPlan.is_incentive_plan) {
    let incentiveHostPlanIndex = state.incentive_host_plan_index;
    let hostPlanObject = state.plans[incentiveHostPlanIndex];
    if (hostPlanObject) {
      let hiddenProducts = state.hidden_products_association[hostPlanObject.code];
      if (hiddenProducts[gatewayKey] && hiddenProducts[state.selected_gateway]) {
        const { sku: oldSku, promo_code: newPromoCode } = hiddenProducts[gatewayKey];
        const { sku: newSku, promo_code: oldPromoCode } = hiddenProducts[state.selected_gateway];
        if (oldSku !== newSku || oldPromoCode !== newPromoCode) {
          resetIncentive();
        }
      } else {
        resetIncentive();
      }
    }
  }
}

export function toggleIncentive(show = true) {
  let incentiveElement = document.querySelector('#hidden-product-wrapper');
  let display = true;
  if (!show) {
    display = false;
  }
  incentiveElement.style.display = display ? 'block' : 'none';

  // For bundle cart implmentation
  if (state.proplan_packages !== null) {
    if (display) {
      $('html,body').animate({
        scrollTop: $('#payment-form').offset().top,
      });
    }
  }
  else {
    let paymentButtonWrapperElement = document.querySelector('#payment-button');
    paymentButtonWrapperElement.style.display = display ? 'none' : 'block';
    document.querySelector('#payment_gateways').click();
  }
}

export function getGatewayIncentiveDetails(planObject = null) {
  if (!planObject) planObject = state.selected_plan;

  let gatewayIncentivePlans = state.gateway_incentives;
  if (gatewayIncentivePlans) {
    gatewayIncentivePlans = gatewayIncentivePlans[planObject.code] ? gatewayIncentivePlans[planObject.code] : {};
  } else {
    return false;
  }

  let gatewayIncentivePlanDetailsObject = gatewayIncentivePlans[state.selected_gateway];

  return gatewayIncentivePlanDetailsObject && isGatewayAvailableAndLoaded(gatewayIncentivePlanDetailsObject.targeted_payment_gateway)
    ? gatewayIncentivePlanDetailsObject
    : false;
}

export function selectGatewayIncentive() {
  let gatewayElement;
  let gatewayIncentiveDetails = getGatewayIncentiveDetails();
  const { promo_code: promoCode, targeted_payment_gateway: targetedPaymentGateway } = gatewayIncentiveDetails;

  // For bundle cart implmentation
  if (state.proplan_packages !== null) {
    gatewayElement = document.querySelector('#payment_gateways .gateway-method[data-name="' + targetedPaymentGateway + '"]');
    gatewayElement.firstElementChild.click();
    $('html,body').animate({
      scrollTop: $('#payment_gateways').offset().top,
    });
  }
  else {
    gatewayElement = document.querySelector('#payment_gateways .gateway-method.active');
    gatewayElement.click();
  }

  setState({
    gateway_incentive_promo_code: promoCode,
    selected_gateway: targetedPaymentGateway,
    coupon_code: '',
    selected_gateway_name: gatewayElement.getAttribute('data-gateway-text')
  });
}

export function resetGatewayIncentive() {
  setState({ gateway_incentive_promo_code: '' });
}

export function toggleGatewayIncentive(show = true) {
  let gatewayIncentiveElement = document.querySelector('#gateway-incentive-wrapper');
  let display = true;
  if (!show) {
    display = false;
  }
  gatewayIncentiveElement.style.display = display ? 'block' : 'none';

  // For bundle cart implmentation
  if (state.proplan_packages !== null) {
    if (display) {
      $('html,body').animate({
        scrollTop: $('#payment-form').offset().top,
      });
    }
  }
  else {
    let paymentButtonWrapperElement = document.querySelector('#payment-button');
    paymentButtonWrapperElement.style.display = display ? 'none' : 'block';
  }
}

export function isGatewayAvailableAndLoaded(gatewayLogicalKey) {
  const selectedPlanObject = state.selected_plan;
  let isAvailable = selectedPlanObject.gateways.find(gateway => {
    return conditionalGateways[gateway.logical_key] !== false && gateway.logical_key == gatewayLogicalKey;
  });
  return isAvailable ? true : false;
}

export function getPhasePlanDescription(planObject) {
  try {
    let planDescription = JSON.parse(planObject.description);
    return planDescription.type == 'phase' ? planDescription : false;
  } catch (err) { }

  return false;
}

export function toggleLoader(show) {
  let cartWrapperElements = document.querySelector('#cart-wrapper');
  let payBtnElements = document.querySelectorAll('.payment-btn');
  let inputElementsElements = document.querySelectorAll('.email, .payment_box, .card-holder, .password');

  if (show) {
    cartWrapperElements.classList.add('submitting');

    for (const ele of payBtnElements) {
      ele.classList.add('submitting-data');
    }

    for (const ele of inputElementsElements) {
      ele.classList.add('show-input-loader');
    }
    return;
  }

  cartWrapperElements.classList.remove('submitting');

  for (const ele of payBtnElements) {
    ele.classList.remove('submitting-data');
  }

  for (const ele of inputElementsElements) {
    ele.classList.remove('show-input-loader');
  }
}

export function getPlanBillingCycle(planObject = null) {
  if (!planObject) planObject = state.selected_plan;

  /* If is trail plan */
  if (isTrialPlan(planObject)) {
    let setupFee = planObject.setup_fee;
    if (setupFee > 0) {
      return 'trial';
    }
    return 'free-trial';
  }

  let planTitle = `${planObject.interval_length} ${planObject.interval_unit}`;
  planTitle = planTitle.toLocaleLowerCase();

  switch (planTitle) {
    case '1 months':
      return 'monthly';

    case '3 months':
      return 'quarterly';

    case '6 months':
      return 'semiannually';

    case '12 months':
      return 'annually';

    case '24 months':
      return 'biannually';

    case '36 months':
      return 'triennially';

    case '60 months':
      return '5 year';

    default:
      return planTitle;
  }
}

export function getInputValue(inputSelector) {
  let element = document.querySelector(inputSelector);
  if (element) return element.value;
  return '';
}

export function splitIntoFirstAndSecondName(name) {
  const [first, ...rest] = name.split(' ');
  return [first, rest.join(' ')];
}

export function showErrorMessagePopup({ errorHeading = null, errorMessage = null, cb = () => { }, showCta = true, showDomMsg = true, ...rest }) {
  const { errors, coupon_code } = state;
  const domMsg = errorMessage?.includes(ALREADY_SUBSCRIPTION) ? ` ${errors.dom_message}` : '';
  const isPLGCheckoutTemplate = PLG_CHECKOUT_TEMPLATES.includes(state?.template_name);
  const isWindowsApp = WINDOWS_IOS_CHECKOUT_TEMPLATES.includes(state?.template_name) && getOSDetect() === OS_WINDOWS;

  let check_insufficient = false;
  let check_trial_avail = false;
  let cta_block = '<button type="button" id="modalOKBtn" class="openPopupConfirmBtn click_on_trial">' + 'OK' + '</button>';

  if (state?.template_name === 'recurly-app-email' && /already availed/i.test(errorMessage || '')) {
    // one-tap email checkout: the trial was used before, send them to the regular order page
    errorHeading = 'Free trial already used';
    showDomMsg = false;
    cta_block = '<a href="/order/" id="modalOKBtn" class="openPopupConfirmBtn click_on_trial" style="display:block;text-align:center;text-decoration:none">View plans</a>';
  } else if (isPLGCheckoutTemplate || isWindowsApp) {
    if (errorMessage?.includes(INSUFFICIENT_FUND)) {
      check_insufficient = true;
      cta_block = '<button type="button" id="trialModalBtn" class="get_hidden_product">Get Free Trial</button>';
    } else if (errorMessage?.includes(ALREADY_AVAILED)) {
      check_trial_avail = true;
    }
  } else {
    if (errorMessage?.includes(INSUFFICIENT_FUND) && !coupon_code) {
      check_insufficient = true;
      errorHeading = errors.insufficient_title;
      errorMessage = errors.insufficient_desc;
      cta_block = `<button type="button" id="insufficientModalBtn" class="continue_with_product">${errors.insufficient_cta}</button>`;
    }
  }

  const modalErrorContent =
    '<div class="custom-modalError">' +
    '<div class="modalError-header">' +
    '<h2>' + (errorHeading || 'Error Detected') + '</h2>' +
    '</div>' +
    '<div class="modalError-body">' +
    '<p>' + (errorMessage || errors.internal_error) + '</p>' +
    (showDomMsg ? ('<p>' + domMsg + '</p>') : '') +
    '</div>' +
    (showCta ? cta_block : '') +
    '</div>';

  openCustomModal(modalErrorContent, 'errorModalId', 'errorModalClass', '512px', true, true);

  const handleAppEvent = () => {
    if (isPLGCheckoutTemplate || isWindowsApp) {
      let response = "";
      let message = "";

      const urlParams = getParamFromURL();
      const windows_treatment = urlParams.get('windows_treatment');
      const decodedStatus = windows_treatment && decodeURIComponent(windows_treatment);

      if (check_insufficient) {
        response = 'insufficient_funds';
        message = "windows_payment_not_completed";
      } else if (check_trial_avail && decodedStatus === 'trial_without_cc') {
        response = 'Desktop app, I expect a response!';
        message = "windows_trial_already_avail";
      } else {
        response = 'Desktop app, I expect a response!';
        message = "windows_payment_unsuccess_close_button";
      }

      appEventHandler(message, response);
    }

    closeCustomPopup();
  };

  const closeModalButton = document.querySelector('.closeCartModal');
  if (closeModalButton) {
    closeModalButton.addEventListener('click', () => {
      handleAppEvent();
      cb(); // Optionally, invoke the callback after closing the modal
    });
  }

  const modalOkBtn = document.getElementById('modalOKBtn');
  if (modalOkBtn) {
    modalOkBtn.addEventListener('click', handleAppEvent);
  }

  if (isPLGCheckoutTemplate || isWindowsApp) {
    const trialModalBtn = document.getElementById('trialModalBtn');
    if (trialModalBtn) {
      trialModalBtn.addEventListener('click', () => {
        closeCustomPopup();
        trialModalPopup();
      });
    }
  }

  const insufficientModalBtn = document.getElementById('insufficientModalBtn');
  if (insufficientModalBtn) {
    insufficientModalBtn.addEventListener('click', () => {
      applyCouponCode('extra20balance', true, true);
      document.querySelector('#desktop-coupon-box').style.display = 'none';
      closeCustomPopup();
    });
  }
}

// For PLG Templates
export function trialModalPopup() {
  const response = 'Desktop app, I expect a response!';
  const message = 'windows_trial_popup_opened';

  appEventHandler(message, response);
  document.getElementById('trialModal').style.display = 'block';
}

export function handlePromise(promise) {
  return promise.then(data => [data, undefined]).catch(error => Promise.resolve([undefined, error]));
}

export function showInputError(inputElement, errorMessage = null) {
  inputElement.classList.add('error');
  if (errorMessage) inputElement.nextElementSibling.innerHTML = errorMessage;
  inputElement.nextElementSibling.style.display = 'block';

  const errorElem = inputElement?.nextElementSibling?.nextElementSibling;
  if ( errorElem && errorElem.classList.contains('error-message') ) {
    errorElem.style.display = 'block';
  }
}

export function removeInputError(inputElement) {
  inputElement.classList.remove('error');
  if (inputElement?.nextElementSibling) {
    inputElement.nextElementSibling.style.display = 'none';
  }

  const errorElem = inputElement?.nextElementSibling?.nextElementSibling;
  if ( errorElem && errorElem.classList.contains('error-message') ) {
    errorElem.style.display = 'none';
  }
}

export function showTeamsMessage() {
  const teamsMessage = document.querySelector('.teams-message');
  if (teamsMessage) {
    teamsMessage.style.display = 'block';
  }
}

export function removeTeamsMessage() {
  const teamsMessage = document.querySelector('.teams-message');
  if (teamsMessage) {
    teamsMessage.style.display = 'none';
  }
}

export function showRemoveValidationCheck(selector, classType, isShow = true) {
  const showCheck = document.querySelector(selector);
  if (showCheck) {
    if (isShow && classType) {
      showCheck.classList.add(classType);
    } else {
      // Remove only known success/error classes, not everything
      showCheck.classList.remove('show-success', 'show-error');
    }
  }
}

export function addClass(selector, classToBeAdded) {
  [...document.querySelectorAll(selector)].map(x => x.classList.add(classToBeAdded));
}

export function removeClass(selector, classToBeRemoved) {
  [...document.querySelectorAll(selector)].map(x => x.classList.remove(classToBeRemoved));
}

export function ifApplePayAttachedWithAnyPlan() {
  state.plans.filter(function (plan) {
    let filteredGateways = plan.gateways.filter(function (gateway) {
      return gateway.logical_key.toLowerCase() == 'applepay';
    });

    return filteredGateways.length;
  });
  return false;
}

export function sendGaCheckoutSuccessEvent() {
  var selectedPlanBillingCycle = getPlanBillingCycle();
  sendGaCustomEvent('Order Cart', 'Form Submission', selectedPlanBillingCycle);
}

export function sendGaCheckoutFailureEvent(message) {
  sendGaCustomEvent('Order Cart', 'Cart Error', message);
}

export function sendGaCustomEvent(category, action, label, value) {
  var data = {
    event: 'GADynamicEvent',
    'gtm.element.dataset.eventcategory': category,
    'gtm.element.dataset.eventaction': action,
    'gtm.element.dataset.eventlabel': label,
  };

  if (typeof value !== 'undefined') {
    data['gtm.element.dataset.eventvalue'] = value;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export function sendGa4CustomEvent(eventName, eventVariables) {
  var data = {
    event: eventName,
    ...eventVariables,
  };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
}

export function addAllSpecialDiscountedAddons() {
  removeAllSelectedSpecialAddons();
  const planObject = state.selected_plan;
  const specialAddonWrapper = document.querySelector('.pure-circle-all-box');

  let availableSpecialDiscountedAddons = planObject.addons.filter(addon => constant.specialDiscountedAddonList.includes(addon.code))
    .map(obj => obj.code);
  if (availableSpecialDiscountedAddons.length) {
    specialAddonWrapper.classList.add('active');
    addAddon(availableSpecialDiscountedAddons);
  }
}

export function removeAllSpecialDiscountedAddons() {
  const planObject = state.selected_plan;
  const specialAddonWrapper = document.querySelector('.pure-circle-all-box');

  let selectedAddons = state.selected_addons ? state.selected_addons : [];
  let selectedSpecialAddons = selectedAddons.filter(addon_code => constant.specialDiscountedAddonList.includes(addon_code));

  if (selectedSpecialAddons.length) {
    removeAddon(selectedSpecialAddons);
    specialAddonWrapper.classList.remove('active');
  }
}
//Special Addons Add All Btn
export function addAllSpecialAddons() {
  const planObject = state.selected_plan;
  const specialAddonWrapper = document.querySelector('.pure-circle-all-box');

  setProplanCode();

  let availableSpecialAddons = planObject.addons.filter(addon => constant.specialAddonList.includes(addon.code))
    .map(obj => obj.code);
  if (availableSpecialAddons.length) {
    specialAddonWrapper?.classList.add('active');
    addAddon(availableSpecialAddons);
  }
}
//Special Addons Remove All Btn
export function removeAllSelectedSpecialAddons() {
  let selectedAddons = state.selected_addons ? state.selected_addons : [];
  let selectedSpecialAddons = selectedAddons.filter(addon_code => constant.specialAddonList.includes(addon_code));
  const specialAddonWrapper = document.querySelector('.pure-circle-all-box');

  if (selectedSpecialAddons.length) {
    removeAddon(selectedSpecialAddons);
    specialAddonWrapper.classList.remove('active');
  }

  setState({ proplan_code: null });
}

// Add PowerPack
export function addPowerPack() {
  const powerPackAddonWrapper = document.querySelector(".pro-pure-vpn-addons");
  const planObject = state.selected_plan;
  setProplanCode();

  const availableVpnAddons = planObject.addons
    .filter((addon) => constant.powerPackAddon == addon.code)
    .map((obj) => obj.code);

  if (powerPackAddonWrapper) {
    if (availableVpnAddons.length) {
      openAddonsCountryPopup(availableVpnAddons, () => {
        const dedicatedIPWrapper = document.querySelector(
          '.pro-pure-vpn-addons .vpn-addon-box[addon-code="dedicated_ip"]'
        );
        const portForwardingWrapper = document.querySelector(
          '.pro-pure-vpn-addons .vpn-addon-box[addon-code="port_forwarding"]'
        );
        if (dedicatedIPWrapper?.classList.contains("active")) {
          removeAddon("dedicated_ip");
          dedicatedIPWrapper.classList.remove("active");
        }
        if (portForwardingWrapper?.classList.contains("active")) {
          removeAddon("port_forwarding");
          portForwardingWrapper.classList.remove("active");
        }

        const powerpackBtn = document.querySelector('#powerpack-btn');
        const added = powerpackBtn.querySelector('.add-all');
        const remove = powerpackBtn.querySelector('.remove-all');

        added.style.display = 'none';
        remove.style.display = 'block';

        powerpackBtn.classList.add('remove-pp');

        const vpnCombo = document.querySelector('.addon-vpn-combo');
        if (vpnCombo) {
          vpnCombo.classList.add('active');
        }

        const addonVpnBox = document.querySelector('.addon-vpn-box');
        if (addonVpnBox) {
          addonVpnBox.classList.add('active');
        }
      });
    }
  }
}


// Remove PowerPack
export function removePowerPack() {
  let selectedAddons = state.selected_addons ? state.selected_addons : [];
  let availableVpnAddons = selectedAddons.filter(
    (addon_code) => constant.powerPackAddon == addon_code
  );
  if (availableVpnAddons.length) {
    removeAddon(availableVpnAddons);
  }
}

export function calculateAllSpecialAddonTotalPrice() {
  const planObject = state.selected_plan;

  let proplanPkg = state?.proplan_packages?.[planObject.code];
  if (proplanPkg && proplanPkg[state?.proplan_index]) {
    let proplanPkgInfo = proplanPkg[state?.proplan_index]?.labels?.product_info;
    if (proplanPkgInfo) {
      let availableSpecialAddons = planObject.addons.filter(addon => constant.specialAddonList.includes(addon.code));
      let availableDiscountedSpecialAddons = proplanPkgInfo.addons.filter(addon => constant.specialAddonList.includes(addon.code));
      return [Number(sumAllAddonPrices(availableSpecialAddons)), Number(sumAllAddonPrices(availableDiscountedSpecialAddons))];
    }
  }

  let availableSpecialAddons = planObject.addons.filter(addon => constant.specialAddonList.includes(addon.code));
  let availableDiscountedSpecialAddons = planObject.addons.filter(addon => constant.specialAddonList.includes(addon.code));
  return [Number(sumAllAddonPrices(availableSpecialAddons)), Number(sumAllAddonPrices(availableDiscountedSpecialAddons))];
}
//PowerPack Calculations
export function calculatePowerPackDiscountedPrice() {
  const planObject = state.selected_plan;
  let availableDiscountedPowerPackAddons = planObject.addons.filter(addon => constant.powerPackAddon == addon.code);
  return Number(sumAllAddonPrices(availableDiscountedPowerPackAddons));
}

export function calculatePowerPackMonthlyOldPrice() {
  let currencyCode = state.currency_code ? state.currency_code : 'USD';
  let powerPackOldPrice = cartState.old_prices[currencyCode].port_forwarding_with_dedicated_ip;
  return Number(powerPackOldPrice);
}

export function calculateSpecialAddonOldPrice(addonCode) {
  const selectedPlan = getSelectedPlan();
  let currencyCode = state.currency_code ? state.currency_code : 'USD';

  let specialAddonsoldPrices = state.special_addons_old_prices ? state.special_addons_old_prices : {};
  let monthlyOldPrice = specialAddonsoldPrices[currencyCode] && specialAddonsoldPrices[currencyCode][addonCode] ? specialAddonsoldPrices[currencyCode][addonCode] : 0;

  return monthlyOldPrice ? Number(monthlyOldPrice) : null;
}

export function sumAllAddonPrices(addons = [], requiredOnly = null, exclude = []) {
  let sumUnitAmount = addons.reduce((acc, addon) => {
    if (requiredOnly) {
      return acc + (addon.optional == '0' && !exclude.includes(addon.code) ? addon.unit_amount : 0);
    }
    else {
      return acc + addon.unit_amount;
    }
  }, 0);

  return sumUnitAmount;
}

export function sumAllAddonQuantityPrices(addons = [], requiredOnly = null, quantity = '1', exclude = []) {
  const {RESIDENTIAL_NETWORK_BANDWIDTH} = constant;

  let sumUnitAmount = addons.reduce((acc, addon) => {
    if (requiredOnly) {
      if(addon.code == RESIDENTIAL_NETWORK_BANDWIDTH && addon.tier_type == 'stairstep') {
        const bandwidthTier = addon.tiers.find(item => item.quantity === Number(quantity));

        return acc + (addon.optional == '0' && !exclude.includes(addon.code) ? bandwidthTier?.unit_amount : 0);
      }

      return acc + (addon.optional == '0' && !exclude.includes(addon.code) ? addon.unit_amount : 0);
    }
    else {
      return acc + addon.unit_amount;
    }
  }, 0);

  return sumUnitAmount;
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}

export function signupFormHandling(action) {
  let passField = document.getElementById('password_field');
  let emailField = document.getElementById('email_field');
  let input_pwd = document.getElementById('input_password');
  let input_mail = document.getElementById('input_email');
  if (action === "hide") {
    passField?.classList.add('no-padd-bg');
    input_pwd?.setAttribute('disabled', true);
    emailField?.classList.add('no-padd-bg');
    input_mail?.setAttribute('disabled', true);
    document.getElementById('cancel-email')?.classList.add('enabled');
  }
  else {
    passField?.classList.remove('no-padd-bg')
    input_pwd?.removeAttribute('disabled');
    emailField?.classList.remove('no-padd-bg')
    input_mail?.removeAttribute('disabled');
    document.getElementById('cancel-email')?.classList.remove('enabled');
    document.cookie = 'cart_info=; Max-Age=0; path=/; domain=.purevpn.com';
  }
}

let crossbtn = document.querySelector('#cancel-email');
crossbtn?.addEventListener('click', () => {
  signupFormHandling('show');
});

export function setProplanCode() {
  const planObject = state.selected_plan;
  const proplanPackages = state.proplan_packages;

  const selectedPRoplanPkg = proplanPackages?.[planObject.code]?.[state?.proplan_index];
  if (selectedPRoplanPkg && selectedPRoplanPkg.labels?.proplan_products) {
    setState({ proplan_code: selectedPRoplanPkg.labels?.proplan_products });
  } else {
    setState({ proplan_code: null });
  }
}

export function resetPaymentAndIncentive(target = undefined) {
  // close all payment gateways
  document.querySelectorAll('.accordion__heading').forEach(heading => {
    if (heading !== target) {
      heading.classList.remove('accordion__heading-active');
      let siblingElement = heading.nextElementSibling;
      siblingElement.style.display = null;
      siblingElement.classList.remove('accodrion__content-show');
    }
  });

  // hide product incentive if exist
  let incentiveElement = document.querySelector('#hidden-product-wrapper');
  if (incentiveElement) {
    incentiveElement.style.display = 'none';
  }

  // hide gateway incentive if exist
  let gateIncentiveElement = document.querySelector('#gateway-incentive-wrapper');
  if (gateIncentiveElement) {
    gateIncentiveElement.style.display = 'none';
  }
}

export function searchAndSelectPlan(tabName, planType = null) {
  let currentPlan = null;
  //search with plan type
  if (planType) {
    currentPlan = document.querySelector(`.plan-box-wrapper.${tabName} .plus-border.${planType} .cart-box`);
  } else {
    if (!currentPlan) currentPlan = document.querySelector(`.plan-box-wrapper.${tabName} .plus-border.vpn_max .cart-box`); //select max plan
    if (!currentPlan) currentPlan = document.querySelector(`.plan-box-wrapper.${tabName} .plus-border.vpn_plus .cart-box`); //select plus plan
    if (!currentPlan) currentPlan = document.querySelector(`.plan-box-wrapper.${tabName} .plus-border.vpn_standard .cart-box`); //select standard plan
  }

  if (currentPlan) {
    let planIndex = currentPlan.getAttribute('data-key');
    let planCode = currentPlan.getAttribute('data-plan-code');
    document.querySelectorAll('[data-plan-code="' + planCode + '"]').forEach(e => e.click());

    setState({ proplan_index: planIndex, proplan_code: null });
    removeAllSelectedSpecialAddons();
    resetPaymentAndIncentive();
    return true;
  }
  return false;
}

export function isValidJSON(jsonString) {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (err) {
    return false;
  }
}

export function gmailDomainCorrection(value) {
  const gmailIncorrectWords = [
    'gnail',
    'gnial',
    'gmial',
    'gamil'
  ]
  const prefixEmail = value.substring(0, value.indexOf("@") + 1);
  const postfixEmail = value.substring(value.indexOf("@") + 1);
  const domainCheck = gmailIncorrectWords.some(item => postfixEmail.includes(item));
  const topLevelDomain = postfixEmail.split('.')[1];
  const correctEmail = domainCheck ? `${prefixEmail}gmail.${topLevelDomain}` : value;

  // Condition for .com fix
  return correctEmail?.includes(`@gmail.${topLevelDomain}`)
    ? correctEmail?.replace(`@gmail.${topLevelDomain}`, '@gmail.com')
    : undefined;
}

export function openCustomModal(modalContent, modalId, modalClass, widthModal = '770px', showCloseButton = true, closeOnOverlayClick = true) {

  let customCartPopup = document.getElementById(modalId);
  let bodyElement = document.getElementsByTagName('body')[0];
  let cartPopup; // Define cartPopup here

  // Check if the modal already exists
  if (!customCartPopup) {
    customCartPopup = document.createElement('div');
    customCartPopup.id = modalId;
    customCartPopup.className = `cartPopup ${modalClass}`;
    customCartPopup.style.display = 'flex';
    bodyElement.classList.add('cartPopupOpen');

    const cartPopupWrap = document.createElement('div');
    cartPopupWrap.className = 'cartPopup-wrap animate__animated animate__fadeInDown';
    cartPopupWrap.style.maxWidth = widthModal;

    const cartPopupContent = document.createElement('div');
    cartPopupContent.className = 'cartPopup-content';

    if (showCloseButton) {
      const closeButton = document.createElement('span');
      closeButton.className = 'closeCartModal';
      closeButton.textContent = '×';
      closeButton.addEventListener('click', closeCustomModal);
      cartPopupContent.appendChild(closeButton);
    }

    const popupDiv = document.createElement('div');
    popupDiv.className = 'popupHTML';
    popupDiv.innerHTML = modalContent;

    cartPopupContent.appendChild(popupDiv);
    cartPopupWrap.appendChild(cartPopupContent);
    customCartPopup.appendChild(cartPopupWrap);

    document.body.appendChild(customCartPopup);

    cartPopup = customCartPopup; // Assign cartPopup here

    // Optionally close the modal on overlay click
    if (closeOnOverlayClick) {
      window.addEventListener('click', function (event) {
        if (event.target === cartPopup) {
          closeCustomModal();
        }
      });
    }

    if (modalId) {
      let cartPopupBorder = document.querySelector('.cartPopup-wrap');
      if (modalId === 'customcartPopup_purevpn') {
        cartPopupBorder.classList.add('pvpn-bg');
      }
      if (modalId === 'customcartPopup_purekeep') {
        cartPopupBorder.classList.add('pmanager-bg');
      }
      if (modalId === 'customcartPopup_purecrypt') {
        cartPopupBorder.classList.add('fencrypt-bg');
      }
      if (modalId === 'customcartPopup_purescan') {
        cartPopupBorder.classList.add('dsecurity-bg');
      }
    }
  }

  function closeCustomModal() {
    let bodyElement = document.getElementsByTagName('body')[0];
    let cartPopup = document.querySelector('.cartPopup');
    let cartPopupWrapper = document.querySelector('.cartPopup-wrap');

    if (cartPopup) {
      cartPopupWrapper.classList.remove('animate__fadeInDown');
      cartPopupWrapper.classList.add('animate__fadeOutUp');
      bodyElement.classList.remove('cartPopupOpen');

      cartPopup.removeAttribute('id');
      setTimeout(() => {
        cartPopup.remove();
      }, 500); // Adjust the delay to match your animation duration
    }
  }
}

export function closeCustomPopup() {

  let cartPopups = document.querySelector('.cartPopup');
  let cartPopupWraps = document.querySelector('.cartPopup-wrap');
  let bodyElementts = document.getElementsByTagName('body')[0];
  if (cartPopups) {
    // Close the modal with animation
    cartPopupWraps.classList.remove('animate__fadeInDown');
    cartPopupWraps.classList.add('animate__fadeOutUp');
    bodyElementts.classList.remove('cartPopupOpen');

    cartPopups.removeAttribute('id');
    setTimeout(() => {
      cartPopups.remove();
    }, 500); // Adjust the delay to match your animation duration
  }
}

export function appEventHandler(message, response, additionalProps = {}) {
  let _nativeHandler = () => window.chrome ? window.chrome.webview : (window.webkit ?? { messageHandlers: {} }).messageHandlers.addonEventHandler;
  _nativeHandler() && _nativeHandler().postMessage({
    'message': message,
    'response': response,
    ...additionalProps  // Spread any additional properties
  });
}

export function getParamFromURL(key = null) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return key ? urlParams.get(key) : urlParams;
}

export function delayFunction(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// Modified because of sub plan in proplan v2 template
export function selectPlanV2(planIndex, extraState = null, data) {
  let newSelectedPlan = state.plans[planIndex];
  let oldSelectedPlan = state.selected_plan;

  sendGa4EventsOfSelectPlan(newSelectedPlan, oldSelectedPlan);

  let selectedAddons = cartState?.selected_addons || [];
  let disableAddons = cartState?.disable_addons || [];

  if (data) {
    selectedAddons = data?.selectedAddons || [];
    disableAddons = data?.disableAddons || [];
  }

  setState({
    oldSelectedPlan,
    selected_package_index: planIndex,
    selected_plan: newSelectedPlan,
    gateway_incentive_promo_code: '',
    selected_addons: selectedAddons,
    disable_addons: disableAddons,
    ...(extraState && extraState),
  });
}

export function sendGa4EventsOfSelectPlan(newSelectedPlan, oldSelectedPlan) {
  /* remove_from_cart event ga4  */
  if (oldSelectedPlan) {
    let priceValueOld = oldSelectedPlan.adjustment ? oldSelectedPlan.discounted_amount : oldSelectedPlan.unit_amount;
    let items = [
      {
        'discount': oldSelectedPlan.adjustment || 0,
        'item_category': 'plan',
        'item_id': oldSelectedPlan.code,
        'item_name': oldSelectedPlan.name,
        'price': oldSelectedPlan.unit_amount
      }
    ];

    //add vpn addon if team plan is selected
    if (oldSelectedPlan.planGroup === 'teams'){
      const purevpn_addon_detail = oldSelectedPlan.addons.find(el => el.code === constant.PURE_VPN);
      const { addon_amount, addon_quantity } = getAddonAmountAndQuantityForGA4(purevpn_addon_detail, isTeamPlan(oldSelectedPlan));

      items.push({
        'discount': 0,
        'item_category': 'addon',
        'item_id': purevpn_addon_detail.code,
        'item_name': purevpn_addon_detail.name,
        'price': addon_amount/addon_quantity,
        'quantity': addon_quantity,
      });

      priceValueOld += addon_amount
    }
    sendGa4EcommerceEvent('remove_from_cart', items, priceValueOld);
  }

  /* add_to_cart event ga4  */
  let priceValueNew = newSelectedPlan.adjustment ? newSelectedPlan.discounted_amount : newSelectedPlan.unit_amount;;
  let items = [
    {
      'discount': newSelectedPlan.adjustment || 0,
      'item_category': 'plan',
      'item_id': newSelectedPlan.code,
      'item_name': newSelectedPlan.name,
      'price': newSelectedPlan.unit_amount
    }
  ];

  //add vpn addon if team plan is selected
  if (newSelectedPlan.planGroup === 'teams'){
    const purevpn_addon_detail = newSelectedPlan.addons.find(el => el.code === constant.PURE_VPN);
    const { addon_amount, addon_quantity } = getAddonAmountAndQuantityForGA4(purevpn_addon_detail, isTeamPlan(newSelectedPlan));

    items.push({
      'discount': 0,
      'item_category': 'addon',
      'item_id': purevpn_addon_detail.code,
      'item_name': purevpn_addon_detail.name,
      'price': addon_amount/addon_quantity,
      'quantity': addon_quantity,
    });

    priceValueNew += addon_amount;
  }

  sendGa4EcommerceEvent('add_to_cart', items, priceValueNew);
}

// Select plan through plan toggle
export function selectPlanByToggle(selectedPlan, extraState = null) {
  let newSelectedPlan = selectedPlan;
  let oldSelectedPlan = state.selected_plan;

  sendGa4EventsOfSelectPlan(newSelectedPlan, oldSelectedPlan);

  setState({
    oldSelectedPlan,
    selected_plan: newSelectedPlan,
    gateway_incentive_promo_code: '',
    ...(extraState && extraState),
  });
}

// Select Family Plan Toggle functionality
export function selectFamilyPlanToggle(switchBoxElem) {
  const cartState = state;
  const selectedPlan = cartState?.selected_plan;
  let newSelectedPlan = selectedPlan;

  const familySelectedPlan = selectedPlan?.subPlan;
  const familyPlanToggle = switchBoxElem;

  if (familySelectedPlan?.code && familyPlanToggle?.checked) {
    newSelectedPlan = {
      ...familySelectedPlan,
      visible_plan_code: selectedPlan?.visible_plan_code
    };
  } else {
    newSelectedPlan = {
      ...cartState?.oldSelectedPlan,
    };
  }

  /* remove_from_cart event ga4  */
  const oldSelectedPlan = selectedPlan;
  if (oldSelectedPlan) {
    const priceValueOld = oldSelectedPlan.adjustment ? oldSelectedPlan.discounted_amount : oldSelectedPlan.unit_amount;
    const items = [
      {
        discount: oldSelectedPlan.adjustment || 0,
        item_category: 'plan',
        item_id: oldSelectedPlan.code,
        item_name: oldSelectedPlan.name,
        price: oldSelectedPlan.unit_amount,
      },
    ];
    sendGa4EcommerceEvent('remove_from_cart', items, priceValueOld);
  }

  /* add_to_cart event ga4  */
  const priceValueNew = newSelectedPlan.adjustment ? newSelectedPlan.discounted_amount : newSelectedPlan.unit_amount;
  const items = [
    {
      discount: newSelectedPlan.adjustment || 0,
      item_category: 'plan',
      item_id: newSelectedPlan.code,
      item_name: newSelectedPlan.name,
      price: newSelectedPlan.unit_amount,
    },
  ];
  sendGa4EcommerceEvent('add_to_cart', items, priceValueNew);

  setState({
    oldSelectedPlan,
    selected_plan: newSelectedPlan,
    gateway_incentive_promo_code: '',
  });
}

export function updateLabel(labelKey, htmlSelector, dataObj, callback) {
  const { value, selectedPlan, plan } = dataObj;
  const labelValue = selectedPlan?.labels[labelKey] || plan?.labels[labelKey];
  const labelHTML = value.querySelector(htmlSelector);

  if (labelHTML && plan?.subPlan?.labels[labelKey]?.trim()) {
    labelHTML.innerHTML = callback ? callback(labelValue) : `${labelValue}`;
  }
};

export function packagelabelCB(packageLabel) {
  return `<span class="ez-toc-section" id="Standard"></span>${packageLabel}<span class="ez-toc-section-end"></span>`;
};

export function switchActivities(slideCheck) {
  const selectedPlan = document?.querySelector('.plan-box-wrapper.active .cart-box.active-plan');

  // top plan radio btn
  const planSwitchBtn = selectedPlan?.querySelector('.plan-switch-box input[name="checkbox"]');
  const planSwitchText = selectedPlan?.querySelector('.plan-switch-box .switch-text');

  const orderSwitchBtn = document?.querySelector('.plan-switch-box.order-sec input[name="checkbox-order"]');
  const orderSwitchText = document?.querySelector('.plan-switch-box.order-sec .switch-text');

  let radioSldieCheck = !!planSwitchBtn?.checked;

  if (orderSwitchBtn && planSwitchBtn) {
    if (typeof slideCheck !== 'undefined') {
      radioSldieCheck = slideCheck;

      if (!radioSldieCheck) {
        orderSwitchText?.classList.remove('active-text');
        planSwitchText?.classList.remove('active-text');
      } else {
        orderSwitchText?.classList.add('active-text');
        planSwitchText?.classList.add('active-text');
      }

      orderSwitchBtn.checked = radioSldieCheck;
      planSwitchBtn.checked = radioSldieCheck;
    } else {
      if (radioSldieCheck) {
        orderSwitchBtn.checked = false;
        planSwitchBtn.checked = false;

        planSwitchText?.classList.remove('active-text');
        orderSwitchText?.classList.remove('active-text');
      } else {
        orderSwitchBtn.checked = true;
        planSwitchBtn.checked = true;

        planSwitchText?.classList.add('active-text');
        orderSwitchText?.classList.add('active-text');
      }
    }
  }
}

// Function to fetch JSON data from the server and add it to the window object
export async function fetchJsonAndAddToWindow(url, objectName) {
  try {
    // Fetch the JSON file from the server
    let response = await fetch(url);

    // Check if the response is OK (status code 200-299)
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Parse the response as JSON
    let data = await response.json();

    // Add the JSON data to the window object
    window[objectName] = data;
  } catch (error) {
    console.error('Error fetching and adding JSON data to window:', error);
  }
}

export function appCheckoutFailureHandler(template_name, data = {}) {
  const isPLGCheckoutTemplate = PLG_CHECKOUT_TEMPLATES.includes(template_name);
  const isIOSCheckoutTemplate = IOS_CHECKOUT_TEMPLATES.includes(template_name);

  const isWindowsApp = WINDOWS_IOS_CHECKOUT_TEMPLATES.includes(state?.template_name) && getOSDetect() === OS_WINDOWS;
  const isMacApp = WINDOWS_IOS_CHECKOUT_TEMPLATES.includes(state?.template_name) && getOSDetect() === OS_MAC;

  if (isPLGCheckoutTemplate || isWindowsApp) {
    const response = 'Desktop app, I expect a response!';
    const message = "windows_payment_not_completed";

    appEventHandler(message, response);
    $(".custom-model-main3").removeClass('model-open');
  }

  if (isIOSCheckoutTemplate) {
    const response = 'iOS app, I expect a response!';
    const message = "ios_web_checkout_failure";

    appEventHandler(message, response, data);
  }

  if (isMacApp) {
    const response = 'Mac app, I expect a response!';
    const message = "mac_web_checkout_failure";

    appEventHandler(message, response, data);
  }
}

export function hideTeamsMsg() {
  const teamsTab = document.querySelector(".teams-tab.active");
  const teamsMessage = document.querySelector(".teams-message");

  if (teamsMessage) {
    if (teamsTab) {
      teamsMessage.classList.add("hide");
    } else {
      teamsMessage.classList.remove("hide");
    }
  }
}

export function updatePaymentMethodsFields(selectedGateway) {
  window.prevLogicalKey = window.prevLogicalKey ? window.prevLogicalKey : '';

  const moneyBackText = document.querySelector('.payment-method-detail');

  if (moneyBackText) {
    const prevLogicalKey = window.prevLogicalKey;
    const logicalKey = selectedGateway.logical_key;

    if (prevLogicalKey) moneyBackText.classList.remove(prevLogicalKey);
    if (logicalKey) moneyBackText.classList.add(logicalKey);

    window.prevLogicalKey = logicalKey;
  }
}

export function updateTeamsCounter(updatedValue, targetElem) {
  (targetElem || []).forEach(item => {
    item.value = updatedValue;
  });
}

// Formats amount by removing trailing .00 but keeps up to 2 decimal places if needed
export function formatAmount(amount) {
  let isEuroFormat = false;

  if (typeof amount === 'string') {
    if (amount.includes(',')) {
      isEuroFormat = true;
      amount = amount.replace(',', '.'); // normalize to dot for parsing
    }
  }

  amount = Number(amount);
  if (isNaN(amount)) return '';

  let result = amount % 1 === 0 ? amount.toString().split('.')[0] : amount.toFixed(2).replace(/\.00$/, '');

  // If original input was Euro format, return with comma
  if (isEuroFormat) {
    result = result.replace('.', ',');
  }

  return result;
}

export function updateTeamValues(teamQuantity) {
  const teamFieldAll = document.querySelectorAll('.team-input-number');
  teamFieldAll.forEach(item => {
    item.value = teamQuantity;
  });
}

export function handleTeamQuantityClick(event, {
  containerSelector = '.cart-box.active-plan',
  inputSelector = '.team-input-number',
  errorSelector = '.teams-field-error',
  bubbleSelector = '.input-bubble',
} = {}) {
  const btn = event.currentTarget;

  const container = document.querySelector(containerSelector);
  const teamField = container?.querySelector(inputSelector);
  const errorField = container?.querySelectorAll(errorSelector);
  const errorQuantity = container?.querySelectorAll(bubbleSelector);

  if (!teamField) return;

  const isMinus = btn.classList.contains('minus');
  const currentValue = Number(teamField.value);
  const minValue = Number(teamField.min);
  const maxValue = Number(teamField.max);

  const userValue = isMinus ? currentValue - 1 : currentValue + 1;

  if (userValue > maxValue) {
    errorField.forEach(item => {
      item.classList.add('active');
    });
    errorQuantity.forEach(item => {
      item.classList.add('active');
    });
  }

  if ((isMinus && currentValue > minValue) || (!isMinus && currentValue < maxValue)) {
    errorField.forEach(item => {
      item.classList.remove('active');
    });
    errorQuantity.forEach(item => {
      item.classList.remove('active');
    });

    const newValue = isMinus ? currentValue - 1 : currentValue + 1;
    teamField.value = newValue;

    let dedicatedIpsQuantity = Number(cartState?.dedicatedIpsQuantity || 0);
    dedicatedIpsQuantity = newValue < dedicatedIpsQuantity ? newValue : dedicatedIpsQuantity;

    let portFowardingQuantity = Number(cartState?.portFowardingQuantity || 0);
    portFowardingQuantity = newValue < portFowardingQuantity ? newValue : portFowardingQuantity;

    setState({
      teamQuantity: newValue,
      dedicatedIpsQuantity,
      portFowardingQuantity,
    });

    updateTeamValues(newValue);
  }
}

export function handleTeamQuantityBlur(event, {
  containerSelector = '.cart-box.active-plan',
  inputSelector = '.team-input-number',
  errorSelector = '.teams-field-error',
  bubbleSelector = '.input-bubble',
} = {}) {
  const elem = event.currentTarget;
  const container = document.querySelector(containerSelector);
  const teamField = container?.querySelector(inputSelector);
  const errorField = container?.querySelectorAll(errorSelector);
  const errorQuantity = container?.querySelectorAll(bubbleSelector);

  if (!teamField) return;

  errorField.forEach(item => {
    item.classList.remove('active');
  });
  errorQuantity.forEach(item => {
    item.classList.remove('active');
  });

  const maxValue = Number(teamField.max);
  const minValue = Number(teamField.min);
  let value = Number(elem.value);

  if (value > maxValue) {
    value = maxValue;
    elem.value = maxValue;

    errorField.forEach(item => {
      item.classList.add('active');
    });
    errorQuantity.forEach(item => {
      item.classList.add('active');
    });
  }

  if (isNaN(value) || value < minValue) {
    value = minValue;
    elem.value = minValue;
  }

  let dedicatedIpsQuantity = Number(cartState?.dedicatedIpsQuantity || 0);
  dedicatedIpsQuantity = value < dedicatedIpsQuantity ? value : dedicatedIpsQuantity;

  let portFowardingQuantity = Number(cartState?.portFowardingQuantity || 0);
  portFowardingQuantity = value < portFowardingQuantity ? value : portFowardingQuantity;

  setState({
    teamQuantity: value,
    dedicatedIpsQuantity,
    portFowardingQuantity,
  });

  updateTeamValues(value);
}

export function validateEmail(email) {
  var re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function getQueryParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    email: params.get('email') || '',
    planCode: params.get('plan-code') || '',
  };
}

export function isTeamsFreePlan(planObject = null) {
  if (!planObject) planObject = state.selected_plan;
  const planDescription = JSON.parse(planObject?.description || '{}');
  return planDescription?.teams_plan === FREE_PLAN ? true : false;
}

export function getAddonPricePerQuantity(selectedPlan, addonCode, quantity = 0, isPerMonth = false) {
  const {addons, interval_length} = selectedPlan || {};
  const addonDetail = addons?.find(addon => addon.code === addonCode);
  if (!addonDetail) return 0;

  let unitAmount = 0;

  if (addonDetail.tier_type === 'volume' && addonDetail.tiers?.length) {
    const tier = addonDetail.tiers.find(t => t.quantity == quantity);
    if (tier) unitAmount = tier.unit_amount;
  }

  if(isPerMonth) {
    unitAmount = unitAmount/Number(interval_length);
  }

  return unitAmount;
}

// Function to fetch user location and set default country
export async function fetchUserLocationAndSetDefault(countryList, gatewayTaxSummary ) {
  try {
    const response = await fetch('https://www.purevpn.com/wp-json/api/v1/get-user-country-code?t=' + Date.now());
    const data = await response.json();

    if (data && data.country) {
      const countryCode = data.country;
      setState({user_country: countryCode});
      const selectedCountryHiddenField = document.querySelector("input[data-recurly='country']");
      if (selectedCountryHiddenField) selectedCountryHiddenField.value = countryCode;

      //select the country in the dropdown
      const country = countryList.find(c => c.iso2 === countryCode);
      if (country) {
        // Update the selected option
        const optionToSelect = document.getElementById(`vat-${countryCode}`);
        if (optionToSelect) {
          // Remove previous selection
          const previous = document.querySelector('.country-option.option-selected');
          if (previous) {
            previous.classList.remove('option-selected');
          }

          // Add selection to new option
          const optionElement = optionToSelect.closest('.country-option');
          if (optionElement) {
            optionElement.classList.add('option-selected');

            const taxSelected = document.querySelector('.tax-selected');
            taxSelected.innerHTML = optionElement.querySelector('label').innerHTML;
          }
        }

        if(cartState.has_taxable_plan === '1'){
          // Show the dropdown after setting the default country
          gatewayTaxSummary.classList.remove('hide');
        }
      }
    }
  } catch (error) {
    console.log('Failed to fetch location for VAT:', error);
    if(cartState.has_taxable_plan === '1') {
      // Show dropdown even if API fails, so user can still select manually
      gatewayTaxSummary.classList.remove('hide');
    }
  }
}

export function getOSDetect() {
  const ua = navigator.userAgent;
  const platform = navigator.platform;

  // iOS
  if (/iPhone|iPad|iPod/.test(ua)) {
    return OS_IOS;
  }

  // macOS
  if ((platform === "MacIntel" || /Mac/.test(platform) || /Macintosh/.test(ua))) {
    return OS_MAC;
  }

  // Windows
  if (/Win/.test(platform)) {
    return OS_WINDOWS;
  }

  // Android
  if (/Android/.test(ua)) {
    return OS_ANDROID;
  }

  return OS_OTHER;
}

export function isSafariBrowser() {
  const ua = navigator.userAgent;

  const isSafariBrowser =
    /Safari/i.test(ua) &&
    !/CriOS|Chrome|EdgiOS|Edg|FxiOS|Firefox|OPiOS|OPR/i.test(ua);

  const isAppleDevice =
    /iPhone|iPad|iPod|Macintosh/i.test(ua);

  return isAppleDevice && isSafariBrowser;
}

// Apple now allows any WebKit-based browser on iOS/iPadOS to trigger Apple Pay
// (not just Safari), since they all share Safari's WebKit + ApplePaySession
// under Apple's engine policy. Desktop stays Safari-only since Apple Pay on
// Mac is a Safari-only integration (Chrome/Firefox on macOS have no
// ApplePaySession).
export function isApplePayPreferredBrowser() {
  const os = getOSDetect();

  if (os === OS_IOS) {
    return true;
  }

  if (os === OS_MAC) {
    return isSafariBrowser();
  }

  return false;
}